/**
 * SCENE CHƠI ARENA PVE — điều khiển bằng chuột/ chạm, THẢ TƯỚNG Ở TOẠ ĐỘ TỰ CHỌN.
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * ⚠️⚠️ TRÙNG TÊN — ĐỌC TRƯỚC KHI SỬA BẤT CỨ GÌ
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * Repo ĐÃ có `src/scenes/arena-scene.ts` (`ArenaScene`, key `'arena'`): đó là TRẬN 10-WAVE ĐANG
 * CHẠY PRODUCTION, do `game.ts` đăng ký và `Hud` điều khiển. **TUYỆT ĐỐI KHÔNG SỬA FILE ĐÓ.**
 *
 * Người dùng đã nhấn mạnh: **Arena là chế độ BỔ SUNG, KHÔNG thay thế game hiện tại.**
 * Vì vậy:
 *   · class MỚI tên `ArenaBattleScene` (khác `ArenaScene`),
 *   · key Phaser MỚI `'arena-battle'` (KHÁC `'arena'` — trùng key là Phaser có 2 scene cùng khoá và
 *     `scene.getScene('arena')` của `game.ts` trả về scene SAI ⇒ game cũ hỏng),
 *   · file này KHÔNG import `ArenaScene`/ `ArenaView`/ `arena-art.ts` và không đụng `ui/**`.
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * HAI QUYẾT ĐỊNH LỚN — MỖI CÁI LÀ MỘT BẪY NẾU LÀM KIỂU KHÁC
 * ════════════════════════════════════════════════════════════════════════════════════════════
 *
 * 1. QUY ĐỔI MÀN HÌNH → THẾ GIỚI ĐI QUA **DUY NHẤT MỘT ĐƯỜNG**: `cameras.main.getWorldPoint()`.
 *    ⚠️ VÌ SAO KHÔNG DÙNG SONG SONG `camera.pointerToWorld()` CỦA T-C: nó là ĐƯỜNG TÍNH THỨ HAI.
 *    `ArenaCamera` tính hình học từ cỡ THIẾT KẾ `ARENA_CAMERA_VIEW` (1000×600), còn Phaser vẽ theo
 *    `cameras.main` (viewport do scene ép). Hai nguồn cỡ nhìn ⇒ hai toạ độ. Repo đã một lần sập vì
 *    đúng loại lệch này ("bấm giữa sân ra orderX 787 thay vì ~500"). Một đường tính, một nguồn sai.
 *    `ArenaCamera` ở đây chỉ lo ZOOM + CUỘN — việc của nó.
 *    ⚠️ HUD (DOM) thả avatar bằng `clientX/clientY` của PointerEvent, KHÔNG phải toạ độ canvas ⇒
 *    `worldFromScreen(clientX, clientY)` là cửa vào cho HUD, và nó cũng đi qua CHÍNH đường đó
 *    (`scale.transformX/Y` → `getWorldPoint`). Xem chú thích ở phương thức.
 *
 * 2. VIEWPORT ÉP VỀ **CỠ THIẾT KẾ 1000×600**, KHÔNG theo `scale.width`.
 *    Bẫy đã sập (ghi nguyên văn ở `ArenaScene.create`): từng đặt camera theo `scale.width`/`height`
 *    = 1576×404 (cỡ khung chứa) trong khi thế giới 1000×600 ⇒ `getWorldPoint()` sai hoàn toàn. Với
 *    camera CUỘN thì bẫy này còn nặng hơn: sai `viewW` ⇒ sai luôn `scrollX`, tức SAI HAI LẦN.
 *    Phaser ở chế độ FIT tự co giãn ảnh ra khung chứa, nên giữ cỡ thiết kế là cách đúng.
 *    ⚠️ VÀ PHẢI ĐO LẠI SAU KHI ĐỔI MÀN HÌNH: lúc boot khung chứa có thể 0×0 ⇒ canvas 0×0 và MỌI CÚ
 *    BẤM KHÔNG ĂN (lỗi đã sập, xem `Hud.showScreen`). Scene này lắng nghe `scale.resize` VÀ có hàm
 *    `resizeView()` cho bên ngoài gọi lại sau khi đổi màn hình.
 *
 * 3. VÒNG LẶP TICK CỐ ĐỊNH 30Hz — BẮT CHƯỚC **CHÍNH XÁC** `arena-scene.ts` (xem `update`).
 *    Bốn thành phần là MỘT khối, thiếu một cái là hỏng: `acc += realDt * speed` (tua được),
 *    `while (acc >= DT && steps < 12)` (không phụ thuộc FPS), chốt `steps >= 12 ⇒ acc = 0` (chống
 *    spiral-of-death), và `hitStop` (khựng va chạm).
 *
 * ⚠️⚠️ ĐÃ XOÁ HẲN "CHỌN LAND" Ở FILE NÀY — LUẬT ĐỔI, KHÔNG PHẢI "DỌN CHO GỌN".
 * Bản cũ là "LAND LÀ TRÁI TIM": bấm land nào thì land đó sáng và mọi lệnh summon ra đúng land đó,
 * luật nằm ở `sim/arena/land-pick.ts`. `land-pick.ts` đã bị XOÁ; sân nay là không gian 2 CHIỀU TỰ DO
 * có SÔNG + 2 CẦU, và người chơi thả quân ở TOẠ ĐỘ TỰ CHỌN (`summonHero(classId, x, y)`). Vì vậy
 * `on…LandChange`, `selectedLand`/`activeLand`, `setLand`, `landOptions`, `drawLandPicker` và ô chọn
 * land trên sân đều đã bị xoá. Toạ độ sai thì SIM huỷ lệnh + báo lỗi (không trừ tiền) — scene KHÔNG
 * kiểm luật vị trí, để luật chỉ có MỘT bản (ở `sim/arena/deploy-pos.ts`, đã có test).
 */
import Phaser from 'phaser';
import { ArenaWorld, ARENA_WORLD, arenaDist, type ArenaCastFx, type ArenaSide } from '../sim/arena/world';
import { ARENA_HERO_COST, arenaHeroCost, arenaTimeSpeedMul } from '../data/arena';
import type { ClassId } from '../sim/types';
import { DT } from '../sim/formulas';
import { t } from '../i18n';
import { UnitViews, type UnitArtKind } from '../render/unitview';
import {
  ArenaUnitViewsAdapter,
  ARENA_CAMERA_VIEW,
  landscapeRenderScaleFor,
  ARENA_PORTRAIT_MQ,
  makeArenaPortraitBands,
  pickArenaBand,
  type ArenaBandView,
  type ArenaPortraitBands,
  type ArenaWorldLike,
} from '../render/arena-camera';
import { ArenaBattleView, ARENA_UNIT_SCALE, createArenaBattleVisuals, type ArenaShot } from '../render/arena-battle';
import { ArenaUltFx, type ArenaUltWorld } from '../render/arena-ult-fx';
/*
 * ⚠️ LUẬT VỊ TRÍ THẢ QUÂN — IMPORT TỪ MODULE THUẦN ĐÃ CÓ TEST, KHÔNG CHÉP LẠI.
 *
 * `tests/arena-deploy.test.ts` khoá toàn bộ luật bằng số. Nếu ở đây tôi tự viết vài dòng `if` để
 * quyết định "chỗ này có thả được không", thì có HAI bản luật — và bản chạy trong game là bản KHÔNG
 * được test. Đây đúng loại "test xanh mà game sai" mà `tests/arena-input.test.ts` đã dựng bài để chặn.
 *
 * Dùng cho `showDeployGhost`: bóng chỉ được hiện ở chỗ mà `summonHero` SẼ nhận. `DEPLOY_MARGIN` là
 * bản sao có khoá của bán kính TƯỚNG (`arenaDist(20)`) — cùng bán kính mà sim dùng khi kiểm lệnh.
 */
import { DEPLOY_MARGIN, isValidDeployPos } from '../sim/arena/deploy-pos';
/*
 * ⚠️ IMPORT CHO BÓNG XEM TRƯỚC (`ArenaDeployGhost`) — ĐỌC `unitview.ts` TRƯỚC KHI SỬA.
 * Nhân vật KHÔNG phải ảnh đơn: nó là rig ghép từ `art/ai/<class>-parts.png` theo `PARTS_ATLAS`, rồi
 * được tạo dáng bằng xương. Bóng vì thế phải dùng ĐÚNG atlas mảnh + hàm tạo dáng mà `UnitViews` dùng
 * (`PARTS_ATLAS` + `applyPose`), thay vì tự chế một đường vẽ thứ hai — đường thứ hai sẽ lệch hình.
 *
 * ⚠️ VÌ SAO CÁC IMPORT NÀY Ở FILE SCENE CHỨ KHÔNG Ở `render/arena-battle.ts`:
 * `tests/arena-render.test.ts` KHOÁ `arena-battle.ts` không được import `../rig/` hay `../art/`
 * (hợp đồng task-3: tầng vẽ Arena phải DÙNG LẠI `UnitViews`, không tự dựng lớp vẽ nhân vật).
 * Scene là nơi đã dựng `UnitViews` nên nó là chỗ đúng để chạm vào atlas/ dáng.
 */
import { PARTS_ATLAS } from '../art/parts';
import { applyPose } from '../art/pose';
import type { Rig } from '../rig/rig';

/**
 * SỰ KIỆN SCENE ĐẨY RA NGOÀI CHO `Game`/ HUD (yêu cầu #8).
 *
 * Vì sao cùng khuôn với `SceneHooks` của `arena-scene.ts`: `Game` đã có sẵn cách nối hook cho scene
 * cũ; giữ CÙNG tên trường (`onWorldEvent`/ `onStatusChange`) nghĩa là `Game` nối scene mới bằng đúng
 * đoạn code quen thuộc, không phải học một giao diện thứ hai.
 * ⚠️ HOOK BÁO "ĐỔI LAND" ĐÃ BỊ XOÁ cùng khái niệm "chọn land" (xem khối chú thích đầu file): không còn
 * land thì không còn gì để HUD tô sáng, và giữ hook đó là giữ một API trỏ vào thứ không tồn tại.
 */
export interface ArenaBattleHooks {
  /** một sự kiện trong mô phỏng (đòn đánh, unit chết, Nhà bị đập…) */
  onWorldEvent?: (e: ArenaSimEvent) => void;
  /** trạng thái trận đổi (`prep` → `fighting` → `won`/ `lost`/ `draw`) */
  onStatusChange?: (status: ArenaWorld['status']) => void;
}

/**
 * SỰ KIỆN MÔ PHỎNG ARENA.
 *
 * ⚠️ VÌ SAO CÓ KIỂU RIÊNG THAY VÌ DÙNG `SimEvent` CỦA GAME TD CŨ: `SimEvent` có các loại
 * `'waveStart'`/ `'waveClear'`/ `'buy'`/ `'potion'`… gắn với luật 10-wave; Arena không có wave,
 * không có bình thuốc. Dùng chung kiểu là mở đường cho scene này phát ra một loại sự kiện mà HUD
 * game cũ hiểu sai. Arena bản này chỉ đánh thường nên giữ tập nhỏ, đúng những gì sim thật sự sinh.
 */
export interface ArenaSimEvent {
  type: 'spawn' | 'die' | 'coreHit' | 'error';
  /** toạ độ world của sự kiện (nếu có) — HUD dùng để vẽ dấu chú ý */
  x?: number;
  y?: number;
  /** phe liên quan */
  side?: 'left' | 'right';
}

/**
 * Phần `ArenaWorld` mà scene này THẬT SỰ đọc thêm (ngoài những gì tầng vẽ cần).
 *
 * Khai tối thiểu để nói rõ phụ thuộc: scene cố ý KHÔNG đọc `settings`/ `rng`/ `tally` — nếu ai đó
 * thấy cần thì đó là dấu hiệu scene đang lấn sang việc của sim.
 */
interface ArenaSceneWorld extends ArenaWorldLike {
  status: ArenaWorld['status'];
  resource: ArenaWorld['resource'];
  cores: ArenaWorld['cores'];
  mines: ArenaWorld['mines'];
  /** cờ khựng va chạm — do sim đặt, lớp hiển thị tiêu thụ (xem `update`) */
  hitStop?: number;
  events?: ArenaSimEvent[];
  /**
   * MỘT TICK MÔ PHỎNG. Có trong interface này để scene gọi được `w.update(DT)`.
   * `ArenaWorldLike` của T-C cố ý KHÔNG có `update` (tầng vẽ chỉ đọc `units`/ `time`), nên scene —
   * thứ THẬT SỰ chạy vòng lặp — phải tự khai thêm.
   */
  update(dt: number): void;
  /**
   * ĐỘ DÀI TRẬN (giây) — getter công khai của sim, cần cho mốc tua **×5 ở 10 giây cuối**
   * (`arenaTimeSpeedMul(w.time, w.matchDuration)`, yêu cầu người dùng 03/10/2026).
   *
   * ⚠️ KHÔNG suy từ `ARENA_TICK.matchSeconds`: trận có thể được dựng với `matchSeconds` khác (test/ tool),
   * và `data/arena.ts` không được import `sim/` (vòng import) — đọc thẳng từ world là nguồn duy nhất đúng.
   */
  matchDuration: number;
  /** hàng đợi hiệu ứng chiêu do sim phát (xem `drawSkillFx`) */
  drainCastFx(): ArenaCastFx[];
  /**
   * HÀNG ĐỢI **PHÁT BẮN** do sim phát (mỗi phát = một VỆT ĐẠN để tầng vẽ diễn lại) — xem `ArenaShot`.
   *
   * ⚠️ TUỲ CHỌN (`?`) LÀ CỐ Ý: hợp đồng này đang được `sim-fix` cài. Chưa có thì `drainShots?.()` trả
   * `undefined` ⇒ game chạy y như trước (không vệt đạn), KHÔNG vỡ. Có rồi thì vệt đạn tự hiện.
   *
   * ⚠️ SÁT THƯƠNG KHÔNG PHỤ THUỘC VÀO ĐÂY: sim Arena trúng NGAY mục tiêu (không mô phỏng đạn bay), nên
   * mảng này chỉ để VẼ. Đừng để tầng nào dùng nó để quyết định thời điểm gây sát thương.
   */
  drainShots?(): ArenaShot[];
  /** THẢ TƯỚNG Ở TOẠ ĐỘ TỰ CHỌN — API mới, KHÔNG còn `land` (xem `sim/arena/types.ts`) */
  summonHero(classId: ClassId, x: number, y: number): { ok: boolean; message: string };
  /** MUA NÔNG DÂN Ở TOẠ ĐỘ TỰ CHỌN — cùng luật toạ độ với `summonHero`; `autoMine` xem HUD `tapIconCommand` */
  buyFarmer(x: number, y: number, autoMine?: boolean): { ok: boolean; message: string };
  /**
   * DỮ LIỆU VẼ CỦA ULTIMATE + VÙNG CHÁY — kênh CHẾT (chỉ đọc), sim phát cho tầng vẽ.
   * Lỗi người dùng *"army ult không thấy máy bay, street không thấy … ném bom xăng"* ⇒ scene đọc
   * thẳng 3 getter này qua `ArenaUltFx` thay vì tự suy diễn từ `castFx`.
   */
  readonly arenaUltVisuals: ArenaUltWorld['arenaUltVisuals'];
  readonly fireZonesActive: ArenaUltWorld['fireZonesActive'];
  readonly burningUnits: ArenaUltWorld['burningUnits'];
}

/** Thông tin 1 nút tướng trên HUD — HUD đọc để dựng danh sách class đã mở khoá. */
export interface ArenaHeroOption {
  classId: ClassId;
  cost: number;
}

// ════════════════════════════════════════════════════════════════════════════
// BÓNG XEM TRƯỚC KHI KÉO-THẢ MUA TƯỚNG (GHOST) — task-8
// ════════════════════════════════════════════════════════════════════════════

/**
 * ĐỘ MỜ CỦA BÓNG — ĐÂY LÀ YÊU CẦU TRỰC TIẾP CỦA NGƯỜI DÙNG, KHÔNG PHẢI SỞ THÍCH CỦA TÔI.
 *
 * Nguyên văn: *"khi kéo nhân vật vào chỗ có thể triệu hồi sẽ hiển thị full hình nhân vật đó (trạng
 * thái idle, **hơi mờ mờ**) để tôi ướm thử vị trí thả"*. 0,55 nằm giữa dải 0,5–0,6 mà bản mô tả task
 * cho phép: đủ mờ để mắt đọc ngay "đây là bản xem trước, chưa phải quân thật", mà vẫn đọc rõ dáng
 * nhân vật để ướm chỗ (mờ hơn nữa là không còn ướm được gì).
 *
 * ⚠️ ĐỔI SỐ NÀY THÌ PHẢI CHỤP LẠI ẢNH: `tools/verify-arena-ghost.mjs` so pixel trong vùng bóng với
 * nền sân, nên một alpha quá thấp có thể làm ảnh "không thấy bóng" dù code vẫn chạy đúng.
 */
export const DEPLOY_GHOST_ALPHA = 0.55;

/**
 * NGUỒN DỰNG RIG CHO BÓNG — CỐ Ý HẸP, CHỈ MỘT HÀM.
 *
 * ⚠️ VÌ SAO KHÔNG IMPORT THẲNG `UnitViews`: `unitview.ts` là lớp vẽ DÙNG CHUNG với trận 10-wave đang
 * chạy production. Buộc file này vào class đó nghĩa là mọi thay đổi của nó thành thay đổi phá vỡ chỗ
 * này, và ngược lại. Một giao diện một-hàm nói đúng thứ bóng cần: *"cho tôi một rig của class này"*.
 *
 * ⚠️⚠️ VÌ SAO ĐI QUA `previewRig` CHỨ KHÔNG TỰ GỌI `buildAiCharacterRig`: nhân vật trong game KHÔNG
 * phải một ảnh — nó được GHÉP từ `art/ai/<class>-parts.png` lúc chạy, và `buildView` của `UnitViews`
 * chọn theo thứ tự DÁNG ĐANG MẶC → art AI → rig vector. `previewRig` ĐI ĐÚNG ĐƯỜNG ĐÓ (nó vốn phục vụ
 * tab Trang phục) nên bóng và quân thật không thể lệch hình. Tự gọi `buildAiCharacterRig` ở đây là
 * dựng đường thứ hai, và đường thứ hai sẽ lệch ngay khi ai đó đổi thứ tự ưu tiên trong `buildView`.
 */
export interface DeployGhostRigSource {
  /** Rig của 1 đơn vị có art (class hoặc nông dân), dựng theo ĐÚNG đường `UnitViews` dùng cho quân thật. */
  previewRig(kind: UnitArtKind): Promise<Rig>;
}

/**
 * BÓNG XEM TRƯỚC NHÂN VẬT Ở ĐIỂM SẮP THẢ — hiệu ứng HÌNH ẢNH THUẦN, KHÔNG phải đơn vị.
 *
 * ⚠️⚠️ VÌ SAO PHẢI VẼ Ở TẦNG SCENE (PHASER), KHÔNG PHẢI DOM: nhân vật là rig ghép từ nhiều mảnh
 * (`PARTS_ATLAS`) + dáng idle tính từ xương. DOM không có cách nào hiện ra "full hình nhân vật" cho
 * đúng — cùng lắm là một ảnh đại diện, và người chơi sẽ ướm vị trí bằng một hình KHÁC với hình sắp ra.
 *
 * ⚠️⚠️ BÓNG KHÔNG ĐƯỢC LÀ ĐƠN VỊ CỦA MÔ PHỎNG. Class này chỉ tạo `Phaser.GameObjects.Sprite`; nó
 * KHÔNG chạm `world.units`, không có va chạm, không vào `score()`, không bị `separateUnits` đẩy.
 * Không có đường nào để nó ảnh hưởng tới kết quả trận — đó là điều kiện sống còn: người chơi chỉ
 * đang ƯỚM, chưa ra lệnh.
 *
 * ⚠️ RẺ KHI GỌI LIÊN TỤC: HUD gọi `show()` mỗi `pointermove`. `show()` với CÙNG class chỉ đổi `x`/`y`
 * (không tạo/ huỷ đối tượng). Rig chỉ được dựng lại khi ĐỔI CLASS — tức đúng một lần cho mỗi thao
 * tác kéo, không phải mỗi khung hình.
 *
 * ⚠️ DEPTH: dùng ĐÚNG công thức của `UnitViews` (`y * 10 + z * 0,01`) nên bóng tự sắp lớp theo chiều
 * sâu với quân thật (không đè lên người đứng trước). Trần depth của thế giới là ~6000, còn lớp hiệu
 * ứng chiêu 8000 và HUD Phaser 9000 ⇒ bóng KHÔNG BAO GIỜ che HUD.
 *
 * ⚠️ VÌ SAO CLASS NẰM Ở FILE SCENE, KHÔNG NẰM Ở `render/arena-battle.ts`: file đó bị
 * `tests/arena-render.test.ts` khoá "KHÔNG import `../rig/` hay `../art/`" (hợp đồng task-3: tầng vẽ
 * Arena phải DÙNG LẠI `UnitViews`, không tự dựng lớp vẽ nhân vật). Bóng cần `PARTS_ATLAS` + `applyPose`
 * nên nó thuộc về nơi được phép chạm hai thứ đó — chính là scene, nơi đã dựng `UnitViews`.
 */
export class ArenaDeployGhost {
  private sprites: Phaser.GameObjects.Sprite[] = [];
  private rig: Rig | null = null;
  /**
   * ĐƠN VỊ ĐANG GẮN VỚI BÓNG (`null` = chưa từng hiện).
   * ⚠️ KIỂU LÀ `UnitArtKind` (class HOẶC `'farmer'`), KHÔNG phải `ClassId`: nông dân kéo được y như
   * tướng nên bóng phải biểu diễn được nó. Đây chính là chỗ hẹp đã chặn bóng nông dân ở task-8.
   */
  private kind: UnitArtKind | null = null;
  private x = 0;
  private y = 0;
  /** Ý ĐỊNH hiển thị. Tách khỏi "đã có sprite" vì rig dựng BẤT ĐỒNG BỘ (xem `show`). */
  private want = false;
  private disposed = false;
  /**
   * DẤU HIỆU NHỊP — chống rig của lần dựng CŨ về muộn rồi gắn vào chỗ đã đổi đơn vị/ đã dọn scene.
   * Cùng khuôn `token` mà repo dùng cho các lần nạp bất đồng bộ khác.
   */
  private token = 0;
  /** pha thở của dáng idle — cố định để bóng không "giật" khi `show()` bị gọi lại liên tục */
  private readonly seed = 0.41;

  constructor(
    private readonly scene: Phaser.Scene,
    private readonly source: DeployGhostRigSource,
  ) {}

  /** Bóng có đang thật sự hiện trên sân không (rig đã dựng xong + đang muốn hiện). */
  get isVisible(): boolean {
    return !this.disposed && this.want && this.rig !== null;
  }

  /** Số sprite của bóng — công cụ kiểm chứng đọc để biết bóng có thật sự tồn tại, không chỉ cờ. */
  get spriteCount(): number {
    return this.sprites.length;
  }

  /** Đơn vị đang gắn với bóng (`null` = chưa từng hiện) — công cụ đối chiếu với avatar đang kéo. */
  get shownKind(): UnitArtKind | null {
    return this.kind;
  }

  /**
   * HIỆN/ DI CHUYỂN BÓNG tới toạ độ THẾ GIỚI `(x, y)`.
   *
   * ⚠️ PHẢI CHỊU ĐƯỢC GỌI LIÊN TỤC (`pointermove`) VÀ GỌI LẠI CÙNG TOẠ ĐỘ: cả hai ca đều chỉ
   * `set` vài trường + `place()`, KHÔNG tạo/ huỷ sprite.
   *
   * ⚠️ RIG DỰNG BẤT ĐỒNG BỘ (`previewRig` là `async`): lần `show` ĐẦU TIÊN của một đơn vị sẽ có
   * khung hình chưa có hình. Cách xử lý là `want` + `token` — không chặn `pointermove` (chặn là kéo
   * giật), và rig về muộn vẫn đặt đúng vị trí MỚI NHẤT chứ không phải vị trí lúc gọi.
   */
  show(kind: UnitArtKind, x: number, y: number): void {
    if (this.disposed) return;
    // toạ độ rác (camera chưa sẵn sàng) ⇒ KHÔNG vẽ bóng ở NaN, và cũng không giữ bóng cũ
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      this.hide();
      return;
    }
    this.x = x;
    this.y = y;
    this.want = true;

    if (this.kind === kind) {
      // CÙNG ĐƠN VỊ: đường nóng của `pointermove` — chỉ hiện lại + dời chỗ
      this.applyVisibility();
      this.place();
      return;
    }

    /*
     * ĐỔI ĐƠN VỊ (hoặc lần hiện đầu tiên): bỏ rig cũ rồi dựng rig mới.
     * Bỏ NGAY chứ không giữ lại: nếu giữ, khung hình sau khi thả đơn vị khác vẫn còn hình cũ
     * đứng trên sân ⇒ người chơi ướm bằng một hình KHÔNG PHẢI thứ mình đang kéo.
     */
    this.clearSprites();
    this.rig = null;
    this.kind = kind;
    const token = ++this.token;
    void this.source
      .previewRig(kind)
      .then((rig) => {
        if (this.disposed || token !== this.token) return; // đã đổi đơn vị/ dọn scene ⇒ bỏ rig này
        this.rig = rig;
        this.buildSprites(rig);
        this.applyVisibility();
        this.place();
      })
      .catch((err) => console.warn('[arena] dựng bóng xem trước thất bại — bỏ qua bóng:', err));
  }

  /**
   * TẮT BÓNG. AN TOÀN khi chưa từng hiện và khi gọi 2 lần liên tiếp (hợp đồng trong task).
   *
   * ⚠️ KHÔNG huỷ sprite ở đây: giữ lại cho lần kéo sau cùng class (dựng lại rig mỗi lần kéo là phí,
   * và `previewRig` có thể phải `await` nạp dáng ⇒ bóng hiện chậm ngay lúc bắt đầu kéo). Việc huỷ
   * thật nằm ở `dispose()` — nơi scene chết/ đổi trận.
   */
  hide(): void {
    this.want = false;
    this.applyVisibility();
  }

  /**
   * MỘT KHUNG HÌNH: giữ dáng IDLE (thở nhẹ) và bám toạ độ đang hiện.
   *
   * ⚠️ `state: 'idle'` + `swing: 0` là điều kiện của dáng đứng yên — xem `pose.ts`: nhánh idle mới
   * chạy nhịp `breath`, còn `swing > 0` là nhánh RA ĐÒN. Bóng ở tư thế đánh sẽ làm người chơi tưởng
   * tướng đã ra quân.
   */
  update(t: number): void {
    const rig = this.rig;
    if (this.disposed || !rig || !this.want) return;
    applyPose(rig, {
      state: 'idle',
      t,
      swing: 0,
      facing: 1,
      hpPct: 1,
      seed: this.seed,
      deadFor: 0,
      hitFlash: 0,
    });
    this.place();
  }

  /** DỌN SẠCH — gọi từ `ArenaBattleScene.dispose` (scene thứ ba, vào/ ra nhiều lần một phiên). */
  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.token++; // vô hiệu hoá mọi lần dựng đang chờ
    this.want = false;
    this.clearSprites();
    this.rig = null;
    this.kind = null;
  }

  /** Tạo sprite cho TỪNG MẢNH của rig — ĐÚNG cách `UnitViews.buildView` làm (cùng `PARTS_ATLAS`). */
  private buildSprites(rig: Rig): void {
    this.sprites = rig.parts.map((p) =>
      this.scene.add.sprite(this.x, this.y, PARTS_ATLAS, p.key).setOrigin(0.5, 0.5).setAlpha(DEPLOY_GHOST_ALPHA),
    );
  }

  private clearSprites(): void {
    for (const s of this.sprites) s.destroy();
    this.sprites = [];
  }

  private applyVisibility(): void {
    for (const s of this.sprites) s.setVisible(this.want && !this.disposed);
  }

  /**
   * ĐẶT TỪNG MẢNH THEO XƯƠNG ĐÃ GIẢI + GÁN DEPTH.
   *
   * ⚠️ NHÂN `ARENA_UNIT_SCALE` CHO CẢ TOẠ ĐỘ MẢNH LẪN SCALE — đúng bài học ở `UnitViews.setUnitScale`:
   * chỉ nhân scale thì các mảnh co tại chỗ và nhân vật vẫn cao như cũ (tay/ chân rời ra). Bóng PHẢI
   * cùng hệ số với quân thật, nếu không người chơi ướm bằng một hình to/nhỏ hơn hình sắp ra.
   */
  private place(): void {
    const rig = this.rig;
    if (!rig) return;
    const parts = rig.update();
    const k = ARENA_UNIT_SCALE;
    // cùng công thức depth với `UnitViews.updateView` ⇒ bóng tự sắp lớp với quân thật
    const base = this.y * 10;
    for (let i = 0; i < parts.length; i++) {
      const rp = parts[i];
      const s = this.sprites[i];
      if (!s) continue;
      s.x = this.x + rp.x * k;
      s.y = this.y + rp.y * k;
      s.rotation = rp.rotation;
      s.scaleX = rp.scaleX * k;
      s.scaleY = rp.scaleY * k;
      s.setDepth(base + rp.z * 0.01);
    }
  }
}

export class ArenaBattleScene extends Phaser.Scene {
  /** MÔ PHỎNG — nguồn sự thật duy nhất của trận. Scene chỉ đọc/ gọi lệnh, KHÔNG giữ luật. */
  world: ArenaWorld | null = null;

  /** lớp vẽ thế giới 3 land + 2 Nhà + 4 mine (task-3) */
  view!: ArenaBattleView;
  /** camera cuộn ngang (task-3) — CHỈ lo zoom + cuộn, không giữ toạ độ bấm */
  cam!: ReturnType<typeof createArenaBattleVisuals>['camera'];
  /** lớp vẽ đơn vị dùng chung với game TD (task-3 bọc sẵn) */
  units!: UnitViews;
  private unitAdapter!: ArenaUnitViewsAdapter;
  /**
   * BÓNG XEM TRƯỚC khi kéo avatar mua tướng (`showDeployGhost`/ `hideDeployGhost`).
   *
   * ⚠️ CÔNG KHAI để công cụ kiểm chứng đọc được trạng thái THẬT (`spriteCount`/ `isVisible`) thay vì
   * tin vào cờ DOM — bài học của repo: "DOM báo có phần tử mà ảnh không thấy gì" (vụ toast).
   */
  ghost!: ArenaDeployGhost;
  /** đồng hồ RIÊNG cho dáng idle của bóng — xem `update` (khác `world.time` vì tạm dừng vẫn phải thở) */
  private ghostClock = 0;

  /** tốc độ tua — `1` là chạy thật; HUD có thể đổi (tua nhanh) */
  speed = 1;
  /** tạm dừng mô phỏng (KHÔNG dừng vẽ — người chơi vẫn phải thấy sân) */
  paused = false;
  /**
   * CỔNG BẮT ĐẦU TRẬN — yêu cầu người dùng 02/10/2026: *"khi tôi click vào Arena, màn hình hiển thị
   * nút `Bắt đầu`, tôi phải click Bắt đầu, sẽ đếm lùi 3s (hiển thị số xuất hiện rồi biến mất
   * 3,2,1,Bắt đầu, thì lúc đó game mới bắt đầu)"*.
   *
   * ⚠️ VÌ SAO LÀ CỜ Ở TẦNG SCENE, KHÔNG PHẢI LUẬT MỚI Ở SIM: trận vẫn được dựng + vẽ như cũ
   * (`status = 'prep'`), chỉ VÒNG LẶP TICK bị chặn. Sim không cần biết "đang đếm lùi" ⇒ không sinh ra
   * `prepSeconds` thứ hai và tính TẤT ĐỊNH của sim giữ nguyên (cùng seed + cùng lệnh ⇒ cùng kết quả).
   * ⚠️ Nếu tick sim chạy trong lúc đếm lùi thì đồng hồ trận đã trôi mất 3 giây và quân hai phe đã
   * hành động — đúng thứ người dùng nói là "lúc đó game mới bắt đầu".
   * ⚠️ `attachWorld` đặt lại `false` ⇒ MỖI lần vào Arena đều phải bấm `Bắt đầu`.
   */
  arenaStarted = false;

  /** hook đẩy sự kiện ra `Game`/ HUD */
  hooks: ArenaBattleHooks = {};

  /** bộ tích luỹ thời gian của vòng lặp tick cố định (xem `update`) */
  private acc = 0;
  private frameCount = 0;
  private lastStatus: ArenaWorld['status'] = 'prep';
  /** đệm sự kiện giữa 2 lần `update` — xem `emitEvent` (VÌ SAO CẦN: sự kiện có thể tới từ lệnh UI) */
  private eventBuf: ArenaSimEvent[] = [];
  /** lớp vẽ HIỆU ỨNG CHIÊU (vòng lan + chớp sáng) — xem `drawSkillFx` */
  private fxGfx!: Phaser.GameObjects.Graphics;
  /**
   * HIỆU ỨNG ĐANG CHẠY. `fxGfx` vẽ lại mỗi khung hình từ danh sách này.
   * Vòng đời: `world.castFx` (sim phát) → nạp vào đây → già đi theo `t` → `t >= life` thì bỏ.
   */
  private fxActive: Array<{ x: number; y: number; radius: number; side: ArenaSide; t: number; life: number; skillId: string }> = [];
  /**
   * HIỆU ỨNG ULTIMATE THEO HÌNH ẢNH THẬT (máy bay · bom xăng · vùng cháy) — xem `render/arena-ult-fx.ts`.
   *
   * ⚠️ VÌ SAO TÁCH KHỎI `fxGfx`: `fxGfx` chỉ vẽ VÒNG TRÒN + chớp cho mọi `castFx`, còn máy bay/ bom
   * xăng cần SPRITE THEO ẢNH (lấy đúng art `maybay`/ `xebom` của chế độ đi ải) + đối tượng tồn tại
   * nhiều khung hình (máy bay bay liên tục). Trộn vào một lớp `Graphics` là quay lại đúng bug
   * *"army ult không thấy máy bay"*.
   */
  private ultFx!: ArenaUltFx;
  private hudText?: Phaser.GameObjects.Text;
  private disposed = false;

  /*
   * ════════════════════════════════════════════════════════════════════════════════════════════
   * KHỔ DỌC — HAI TẦNG (nửa sân ĐỊCH trên · nửa sân MÌNH dưới). Xem `makeArenaPortraitBands`.
   * ════════════════════════════════════════════════════════════════════════════════════════════
   * `null` = đang ở khổ NGANG/ desktop (một camera, `#stage` phủ kín màn hình — hành vi cũ, KHÔNG đổi).
   */
  private bands: ArenaPortraitBands | null = null;
  /**
   * `true` = avatar xếp **CỘT DỌC trong dải trống hai bên sân** (mặc định ở khổ dọc); `false` = màn
   * dọc quá cao/ hẹp nên dải trống không đủ chỗ ⇒ HUD lùi về HÀNG NGANG mép dưới, và `applyArenaLayout`
   * đã chừa sẵn chỗ cho hàng đó. Quyết định nằm ở SCENE (không phải HUD) vì chính scene là bên tính ra
   * dải trống; HUD đọc lại qua `arenaPortraitField()` để hai bên không thể lệch nhau.
   */
  private avatarColumns = false;
  /** Camera THỨ HAI cho tầng TRÊN (tầng dưới dùng `cameras.main`) — chỉ tồn tại ở khổ dọc. */
  private bandCam: Phaser.Cameras.Scene2D.Camera | null = null;
  /**
   * ⚠️ CHỐNG ĐỆ QUY: `scale.resize()` (đổi cỡ canvas cho khổ dọc) phát luôn sự kiện `resize` mà
   * `onScaleResize` đang lắng nghe ⇒ nếu không có cờ này thì hàm gọi chính nó vô hạn.
   */
  private applyingLayout = false;
  /** Theo dõi THANH TRÊN + DOCK: dock đổi chiều cao (mua tướng ⇒ thêm avatar) là phải chia lại 2 tầng. */
  private bandObserver: ResizeObserver | null = null;
  /**
   * `devicePixelRatio` đang dùng cho canvas khổ dọc — hình học 2 tầng tính bằng ĐƠN VỊ NỀN (× DPR),
   * còn vạch chia là DOM nên phải chia lại về CSS px (`splitY / bandDpr`).
   */
  private bandDpr = 1;
  /**
   * HAI HÀM CỦA MEDIA QUERY — giữ tham chiếu để `removeEventListener` được (mỗi lần `addEventListener`
   * với closure mới là một listener không gỡ được ⇒ rò rỉ qua từng trận).
   */
  private readonly onPortraitChange = (): void => this.applyArenaLayout();

  constructor() {
    /*
     * ⚠️ KEY PHẢI LÀ `'arena-battle'`, KHÔNG PHẢI `'arena'`.
     * `'arena'` đã bị `ArenaScene` (trận 10-wave, đang chạy production) chiếm. Trùng key ⇒ Phaser có
     * 2 scene cùng khoá và `scene.getScene('arena')` của `game.ts` trả về scene SAI ⇒ hỏng game cũ.
     * Người dùng đã nhấn mạnh Arena là BỔ SUNG, không thay thế.
     */
    super('arena-battle');
  }

  // ════════════════════════════════════════════════════════════════════════
  // VÒNG ĐỜI
  // ════════════════════════════════════════════════════════════════════════

  create(): void {
    /*
     * ⚠️⚠️ VIEWPORT GIỮ ĐÚNG CỠ THIẾT KẾ (1000×700), KHÔNG THEO `scale.width` — BẪY ĐÃ SẬP.
     *
     * Ghi lại nguyên văn từ `ArenaScene.create` (game TD cũ đã dính): sau khi vào trận từ trang chủ,
     * `scale.width/height` = 1576×404 (cỡ khung chứa) nên camera bị đặt thành 1576×404 trong khi thế
     * giới thiết kế chỉ 1000×600 ⇒ `getWorldPoint()` trả toạ độ SAI và MỌI CÚ BẤM LỆCH — đo được:
     * bấm giữa sân ra `orderX 787` thay vì ~500.
     *
     * Với Arena (camera CUỘN) bẫy này còn NẶNG HƠN: sai `viewW` ⇒ sai luôn `scrollX`, và
     * `getWorldPoint()` cộng thêm một lượng lệch nữa — SAI HAI LẦN.
     *
     * Cách đúng: camera giữ cỡ THIẾT KẾ (× DPR — xem `renderScale`/ `applyLandscapeLayout`); Phaser ở
     * chế độ FIT tự co giãn ảnh ra khung chứa, nên `getWorldPoint()` luôn quy đổi đúng. Và cỡ này PHẢI
     * khớp `ARENA_CAMERA_VIEW` mà `ArenaCamera` dùng để tính hình học — lệch là hai đường tính toạ độ
     * khác nhau (xem quyết định #1 đầu file).
     */
    const bootScale = this.landscapeRenderScale();
    this.cameras.main.setViewport(0, 0, ARENA_CAMERA_VIEW.w * bootScale, ARENA_CAMERA_VIEW.h * bootScale);

    // DỰNG TẦNG NHÌN (task-3): lớp vẽ thế giới + camera cuộn
    const visuals = createArenaBattleVisuals(this, ARENA_WORLD.w, ARENA_WORLD.h);
    this.view = visuals.view;
    this.cam = visuals.camera;
    this.units = new UnitViews(this);
    /*
     * ⚠️ NHÂN VẬT NHỎ HƠN CỠ GỐC — yêu cầu người dùng: *"nhân vật ở Arena cũng nhỏ tương xứng đảm bảo
     * nhiều tướng, nhiều quái, nhiều nông dân cũng không bị kẹt hay vướng"*. Lý do chọn 0,6 ở chú
     * thích `ARENA_UNIT_SCALE`. Áp NGAY sau khi tạo `UnitViews` và TRƯỚC khi có đơn vị nào.
     */
    this.units.setUnitScale(ARENA_UNIT_SCALE);
    /*
     * ⚠️ DẤU PHE — yêu cầu người dùng: *"tôi không thể phân biệt được địch với ta, rất khó nhìn"*.
     * Arena là chiến trường 2 phe ĐỐI XỨNG: hai bên dùng CÙNG art AI và cùng bộ class, nên tướng ta
     * và tướng địch chỉ khác chiều quay ⇒ mắt không đọc được. Vòng xanh (ta) / đỏ (địch) dưới chân +
     * nhãn tên theo màu phe là hai tín hiệu KHÔNG phụ thuộc art.
     */
    this.units.setTeamMarkers(true);
    /*
     * ✅ KHÔNG CÒN ÉP KIỂU NÀO Ở ĐÂY — và đó chính là điều đáng ghi lại (bàn giao §3.4 ĐÃ SỬA).
     *
     * Trước đây dòng này là:
     *     new ArenaUnitViewsAdapter(this.units as unknown as ConstructorParameters<…>[0])
     * vì `UnitViews.sync(dt, world: World)` nhận thẳng `World` của game TD CŨ (~150 trường), còn
     * Arena cố ý chỉ có `units` + `time`. `tsc` từ chối và báo thật:
     *     `Type '{ units; time }' is missing the following properties from type 'World':
     *      ultState, convertedOwners, lastBombZone, fireZones, and 125 more.`
     *
     * Cách sửa KHÔNG phải "ép kiểu cho qua" mà là khai ĐÚNG thứ lớp vẽ đọc: `unitview.ts` nay có
     * `UnitViewsWorld { units: UnitViewUnit[]; time }`, với `UnitViewUnit = Pick<Unit, …24 trường…>`.
     * Cả `World` (TD) lẫn `ArenaWorldLike` (Arena) đều thoả cấu trúc đó một cách TỰ NHIÊN.
     *
     * ⚠️⚠️ VÌ SAO ĐIỀU NÀY QUAN TRỌNG HƠN VIỆC "BỎ ĐƯỢC MỘT DÒNG XẤU": `as unknown as` là chỗ
     * TypeScript NGỪNG KIỂM. Với nó, ai đó truyền nhầm một object thiếu `.time` vẫn BIÊN DỊCH ĐƯỢC,
     * và lỗi chỉ lộ ra giữa trận dưới dạng `undefined` chảy vào phép vẽ. Nay `tsc` kiểm THẬT: thiếu
     * một trường là lỗi ngay tại dòng này. Đã tự kiểm chứng bằng cách cố tình bỏ `.time` ⇒ `tsc` đỏ.
     *
     * ⚠️ ĐÁNH ĐỔI ĐÃ CHẤP NHẬN: `unitview.ts` là lớp vẽ DÙNG CHUNG với game 10-wave đang chạy, nên
     * lần sửa này phải được trả giá bằng `npm test` + `verify:arena` + chơi thử 1 trận 10-wave.
     */
    this.unitAdapter = new ArenaUnitViewsAdapter(this.units);

    /*
     * ⚠️ BỎ THANH MANA TRONG ARENA — người dùng: *"bỏ thanh mana của nhân vật trong arena đi nhé"*.
     *
     * Vì sao phải ở SCENE chứ không sửa cứng trong `unitview.ts`: `UnitViews` dùng CHUNG với trận TD
     * 10-wave đang chạy production, nên lớp vẽ KHÔNG được tự biết mình đang vẽ chế độ nào — đúng khuôn
     * `setTeamMarkers(true)` ngay trên. Mặc định của công tắc là `true` ⇒ 10-wave không đổi một pixel.
     *
     * Vì sao Arena không cần thanh mana: tướng Arena KHÔNG tiêu mana (auto dùng chiêu), nên vạch mana
     * chỉ là một vạch rỗng vô nghĩa mà vẫn chiếm chỗ trên nhân vật đã nhỏ (`k = 0,6`).
     */
    this.units.setManaBarVisible(false);

    /*
     * BÓNG XEM TRƯỚC (task-8) — dựng MỘT LẦN cho cả scene, không phải mỗi lần kéo.
     * Nguồn rig là chính `this.units` (xem `DeployGhostRigSource`): `previewRig` đi ĐÚNG đường
     * `buildView` dùng cho quân thật (dáng đang mặc → art AI → rig vector) nên bóng không thể lệch hình.
     */
    this.ghost = new ArenaDeployGhost(this, this.units);

    /*
     * LỚP HIỆU ỨNG CHIÊU — depth 8000: TRÊN mọi đơn vị (depth unit = `u.y * 10`, cao nhất ~6000) và
     * DƯỚI chữ debug (9000). Xem `fxActive`.
     */
    this.fxGfx = this.add.graphics().setDepth(8000);
    /*
     * LỚP HIỆU ỨNG ULTIMATE (máy bay · bom xăng · vùng cháy) — sprite theo ảnh AI của chế độ đi ải.
     * Tạo SAU `fxGfx` nhưng depth riêng (7500/ 7100/ dưới chân unit) nên thứ tự tạo không quyết định
     * lớp; xem `ArenaUltFx`.
     */
    this.ultFx = new ArenaUltFx(this);
    this.hudText = this.add
      .text(8, 6, '', { fontFamily: 'ui-monospace, monospace', fontSize: '11px', color: '#a8a29e' })
      .setDepth(9000)
      .setScrollFactor(0)
      .setAlpha(0.75);

    /*
     * ⚠️ ĐO LẠI KHI KHUNG CHỨA ĐỔI CỠ.
     * Lúc boot khung chứa có thể 0×0 (trang chủ đang hiện) ⇒ canvas 0×0 và MỌI CÚ BẤM KHÔNG ĂN.
     * Phaser KHÔNG tự đo lại khi cửa sổ không đổi kích thước, nên phải lắng nghe `scale.resize` và
     * giữ viewport ở cỡ thiết kế (KHÔNG lấy cỡ mới từ `scale.width` — xem bẫy ngay trên).
     */
    this.scale.on('resize', this.onScaleResize, this);

    /*
     * KHỔ DỌC — 2 TẦNG (xem `applyArenaLayout`). Ba nguồn làm hình học 2 tầng đổi:
     *   · hướng màn hình (media query)  · kích thước thanh trên/ dock (ResizeObserver)
     *   · cửa sổ đổi cỡ (`scale.on('resize')` ở trên)
     * ⚠️ `SLEEP`/ `WAKE` phải có: `Game.exitArena` chỉ `sleep()` scene, KHÔNG `stop()` ⇒ `dispose()`
     * không chạy ở đường đó, mà canvas thì PHẢI trả về cỡ thiết kế cho màn 10-wave/ trang chủ.
     */
    this.setupPortraitWatch();
    this.events.on(Phaser.Scenes.Events.SLEEP, this.onArenaSleep, this);
    this.events.on(Phaser.Scenes.Events.WAKE, this.onArenaWake, this);
    this.applyArenaLayout();

    /*
     * ⚠️ KHÔNG CÒN `input.on('pointerdown', …)` — LUẬT ĐỔI, KHÔNG PHẢI "BỎ SÓT".
     * Bản cũ bắt cú bấm trên sân để CHỌN LAND. Nay không còn land: người chơi thả tướng bằng cách
     * TAP/ KÉO avatar trên HUD (DOM), và HUD gọi `summonHero(classId, x, y)` với toạ độ do
     * `worldFromScreen()` quy đổi. Giữ listener cũ sẽ là một đường chết (không còn việc để làm) và dễ
     * khiến người sau tưởng vẫn còn cơ chế chọn land.
     */

    // dọn khi scene shutdown (màn thứ ba, vào/ ra nhiều lần trong một phiên)
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.dispose, this);
  }

  /** Khung chứa đổi cỡ (hoặc hướng màn hình đổi) ⇒ áp lại bố cục. */
  private onScaleResize(): void {
    if (this.disposed) return;
    /*
     * ⚠️ CHỐNG ĐỆ QUY: ở khổ dọc, `applyArenaLayout` GỌI `scale.resize(vw, vh)` để canvas đúng tỉ lệ
     * màn hình, mà chính lời gọi đó phát ra sự kiện `resize` này. Không có cờ ⇒ đệ quy vô hạn (treo).
     */
    if (this.applyingLayout) return;
    this.applyArenaLayout();
  }

  /**
   * ══════════════════════════════════════════════════════════════════════════════════════════════
   * ÁP BỐ CỤC THEO HƯỚNG MÀN HÌNH — **MỘT CỬA DUY NHẤT** CHO KHỔ NGANG VÀ KHỔ DỌC.
   * ══════════════════════════════════════════════════════════════════════════════════════════════
   *
   * KHỔ NGANG/ DESKTOP (mặc định, KHÔNG ĐỔI GÌ): một camera, viewport = cỡ thiết kế 1000×600, Phaser
   * `Scale.FIT` co giãn canvas ra khung chứa. `#stage` phủ kín màn hình, HUD là lớp phủ — đúng thiết
   * kế "SÂN ĐẤU FULL SCREEN" người dùng đã chốt.
   *
   * KHỔ DỌC (điện thoại, `ARENA_PORTRAIT_MQ`): yêu cầu người dùng *"màn dọc 1/2 sân dọc của player
   * bên dưới, 1/2 sân dọc của enemy bên trên"* ⇒ HAI camera chia canvas thành 2 tầng, mỗi tầng một
   * nửa sân (xem `makeArenaPortraitBands`). Vì canvas phải có TỈ LỆ DỌC, ở đây mới gọi
   * `scale.resize(vw, vh)`.
   *
   * ⚠️⚠️ `scale.resize()` Ở ĐÂY KHÁC HẲN CÁI BẪY ĐÃ GHI TRONG `game.resizeArena()`. Bẫy đó là: đổi
   * `baseSize` sang cỡ khung chứa NHƯNG VẪN ĐỂ camera/ viewport ở cỡ thiết kế ⇒ hai hệ toạ độ lệch
   * nhau ⇒ bấm sai. Ở khổ dọc ta đổi `baseSize` **cùng lúc** với việc dựng lại camera (viewport +
   * zoom + scroll đều tính theo cỡ mới) và `worldFromScreen` chọn ĐÚNG camera của tầng con trỏ đang ở
   * ⇒ hai hệ toạ độ vẫn là MỘT. Bằng chứng là phép đo `worldFromScreen(tâm tầng)` trong
   * `tools/verify-arena-render.mjs` — tâm tầng dưới phải ra (250, 300), tâm tầng trên (750, 300).
   *
   * ⚠️ VÀ PHẢI TRẢ LẠI CỠ THIẾT KẾ khi rời khổ dọc (`teardownPortrait`) — nếu không, màn 10-wave và
   * trang chủ thừa hưởng canvas dọc ⇒ méo. Vì vậy hàm này chạy ở `SLEEP` nữa, không chỉ `SHUTDOWN`.
   */
  private applyArenaLayout(): void {
    if (this.disposed || this.applyingLayout) return;
    const portrait = typeof window !== 'undefined' && window.matchMedia(ARENA_PORTRAIT_MQ).matches;
    if (!portrait) {
      this.applyLandscapeLayout();
      return;
    }
    const host = document.getElementById('arena');
    if (!host) return;
    const vw = Math.round(host.clientWidth);
    const vh = Math.round(host.clientHeight);
    /* Khung còn ẩn (đang ở trang chủ) ⇒ chưa đo được, lần resize sau làm tiếp. */
    if (vw < 2 || vh < 2) return;
    /*
     * CHIỀU CAO THANH TRÊN + DOCK ĐO TỪ DOM — KHÔNG hard-code. Lý do: dock đổi chiều cao khi panel xuống
     * dòng hoặc khi thanh trên xuống hàng lúc đổi ngôn ngữ. Hard-code là quay lại đúng "ĐỜI 1" mà repo
     * đã bỏ (đo được: dock 428px > màn 390px ⇒ tràn).
     *
     * ⚠️⚠️ HÀNG AVATAR **KHÔNG** NẰM TRONG `.arena-dock` — ĐỌC KỸ, ĐÃ ĐO ĐƯỢC.
     * Avatar là các `.arena-drag-icon` trong `.arena-icon-layer` (một lớp RIÊNG, người chơi kéo được),
     * còn `.arena-dock` chỉ chứa các panel. Ở khổ dọc, avatar nay xếp CỘT DỌC TRONG DẢI TRỐNG hai bên
     * sân (yêu cầu người dùng: *"1 cột dọc 6 avatar bên trái"*) nên chúng KHÔNG ăn chiều cao nữa; chỉ
     * khi dải trống quá hẹp (màn dọc rất cao/ hẹp) mới phải lùi về HÀNG NGANG ở mép dưới và lúc đó mới
     * chừa chỗ cho hàng đó — xem `avatarColumns` bên dưới.
     */
    const bar = document.querySelector('.arena-hud-bar')?.getBoundingClientRect().height ?? 0;
    const dockTop = document.querySelector('.arena-dock')?.getBoundingClientRect().top ?? vh;
    /*
     * ⚠️⚠️ ĐỘ PHÂN GIẢI NỀN = CSS px × devicePixelRatio — SỬA LỖI *"ẢNH VỠ"* NGƯỜI DÙNG BÁO.
     *
     * Phaser 4 **KHÔNG còn `resolution`** trong config, và `ScaleManager.resize` đặt
     * `canvas.width/height = baseSize` — tức canvas có ĐÚNG bằng CSS px. Trên điện thoại DPR 2–3, trình
     * duyệt phải PHÓNG TO ảnh canvas 2–3 lần ⇒ mọi nét (chữ, viền Nhà, lính) bị nhoè — đúng thứ người
     * dùng gọi là *"ảnh vỡ"*. ĐO ĐƯỢC trước khi sửa: canvas attr 412×915, CSS 412×915, DPR 3.
     *
     * Cách sửa: cho `baseSize` = kích thước CSS × DPR (canvas attr = 824×1830…) trong khi CSS vẫn
     * 412×915. Phaser tính `displayScale = baseSize / canvasBounds = DPR` ⇒ `transformX/Y` vẫn quy đổi
     * ĐÚNG cú chạm (đó là lý do mọi toạ độ trong file này đi qua `scale.transformX/Y`). Hình học 2 tầng
     * vì thế tính bằng ĐƠN VỊ NỀN (× DPR) — `makeArenaPortraitBands` thuần tỉ lệ nên chỉ cần nhân DPR.
     *
     * 🔢 Trần 3: DPR điện thoại phổ biến là 2–3; cao hơn chỉ tốn GPU mà mắt không thấy.
     */
    const dpr = this.renderScale();
    this.bandDpr = dpr;
    /** Tính 2 tầng với một chiều cao "chừa chỗ dưới" bất kỳ (px CSS) — dùng cho cả hai phương án. */
    const mkBands = (insetBottomCss: number, gutterCss = 0): ArenaPortraitBands =>
      makeArenaPortraitBands({
        vw: Math.floor(vw * dpr),
        vh: Math.floor(vh * dpr),
        insetTop: Math.floor(bar * dpr),
        insetBottom: Math.floor(insetBottomCss * dpr),
        gutter: Math.floor(gutterCss * dpr),
      });
    /*
     * ⚠️⚠️ CỠ AVATAR ĐO TỪ DOM (fallback 44 = cỡ CSS của `.arena-drag-icon`), KHÔNG hard-code hẳn:
     * avatar bị thu nhỏ ở một số chế độ (`.arena-drag-icon` trong CSS đổi cỡ), và ngưỡng quyết định
     * "dải trống có đủ chỗ xếp cột không" phải khớp với ngưỡng của `layoutDefaultAvatars` bên HUD
     * (`bandW < 2·half + 2` ⇒ lùi về hàng) — lệch nhau là scene chừa chỗ cho HÀNG trong khi HUD xếp CỘT
     * (avatar đè sân) hoặc ngược lại.
     */
    let avatarSize = 44;
    for (const el of document.querySelectorAll('.arena-drag-icon')) {
      const r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) {
        avatarSize = Math.min(r.width, r.height);
        break;
      }
    }
    const needStrip = avatarSize + 2; // đúng ngưỡng của `layoutDefaultAvatars`
    /*
     * ⚠️⚠️ BA PHƯƠNG ÁN XẾP AVATAR — CHỌN THEO HÌNH HỌC, KHÔNG THEO CẢM GIÁC:
     *
     *   1. DẢI TRỐNG TỰ NHIÊN ĐỦ RỘNG (màn dọc thường): sân canh giữa, hai dải trống là chỗ cột avatar
     *      — đúng yêu cầu người dùng *"1 cột dọc 6 avatar bên trái"*.
     *   2. DẢI TRỐNG QUÁ HẸP nhưng CHỪA TRƯỚC ĐƯỢC (`gutter`): khi thanh trên/ dock thấp đi thì `panelH`
     *      tăng ⇒ zoom tăng ⇒ sân rộng ra và dải trống co lại (đo được ở 412×915 sau khi bỏ bảng dock:
     *      dải còn ~26px < 44px). Lúc đó chừa `gutter` ở bên trái cho cột avatar, sân DỊCH SANG PHẢI
     *      (`makeArenaPortraitBands` nhận `gutter`). Chỉ nhận nếu sân vẫn gần đầy chiều cao tầng (≥ 85%)
     *      — nếu không thì đánh đổi đó là lỗ thật, xem (3).
     *   3. HÀNG NGANG Ở MÉP DƯỚI: màn dọc rất cao/ hẹp (tỉ lệ > ~2,5) — fit chiều cao bị chặn bởi bề
     *      ngang nên `gutter` làm sân teo hẳn. Lùi về hàng ngang và CHỪA CHỖ cho hàng đó (đo `avatarTop`).
     *
     * ⚠️ Trần 45% chiều cao (đo từ `avatarTop`): avatar là thứ người chơi KÉO ĐƯỢC (vị trí lưu qua
     * `localStorage`), nên một vị trí cũ lạ (avatar nằm giữa màn) sẽ đòi chừa gần hết màn hình ⇒ hai
     * tầng teo lại. Kẹp lại thì avatar đó chỉ ĐÈ lên sân (đúng như ở màn ngang), không phá bố cục.
     */
    const dockInset = Math.max(0, vh - dockTop);
    let bands = mkBands(dockInset);
    /*
     * ⚠️⚠️ `stripLeft` Ở ĐƠN VỊ NỀN (× DPR) CÒN `needStrip` Ở CSS px — PHẢI CHIA `dpr` TRƯỚC KHI SO.
     * LỖI ĐÃ SẬP ĐÚNG MỘT LẦN (và rất khó thấy): ở 412×915 (DPR 2) dải trái thật là 25,2 CSS px nhưng
     * số thô là 50,3 ⇒ so thẳng với ngưỡng 46 là ra "đủ rộng" ⇒ cột avatar được đặt vào dải 25px và
     * ĐÈ LÊN SÂN. Mọi phép so hình học giữa hai hệ này đều phải đi qua `bandDpr`.
     */
    this.avatarColumns = bands.fits && bands.stripLeft / dpr >= needStrip;
    if (!this.avatarColumns) {
      const withGutter = mkBands(dockInset, Math.ceil(avatarSize) + 12);
      if (
        withGutter.fits &&
        withGutter.stripLeft / dpr >= needStrip &&
        withGutter.top.h >= withGutter.panelH * 0.85
      ) {
        bands = withGutter;
        this.avatarColumns = true;
      } else {
        let avatarTop = vh;
        for (const el of document.querySelectorAll('.arena-drag-icon')) {
          const r = el.getBoundingClientRect();
          if (r.height > 0 && r.top < avatarTop) avatarTop = r.top;
        }
        bands = mkBands(Math.min(Math.max(vh - Math.min(dockTop, avatarTop), 0), vh * 0.45));
        this.avatarColumns = false;
      }
    }
    /* Vùng giữa thanh trên và dock quá thấp (bàn phím ảo?) ⇒ lùi về khổ ngang, thà nhỏ còn hơn rác. */
    if (!bands.fits) {
      this.applyLandscapeLayout();
      return;
    }
    this.applyingLayout = true;
    try {
      this.setCanvasGameSize(Math.floor(vw * dpr), Math.floor(vh * dpr));
      this.bands = bands;
      this.applyBand(this.cameras.main, bands.bottom);
      if (!this.bandCam) {
        this.bandCam = this.cameras.add(0, 0, 1, 1);
        /*
         * ⚠️ CHỮ DEBUG (`drawDebugText`) CÓ `setScrollFactor(0)` NÊN NÓ VẼ Ở CẢ 2 CAMERA ⇒ thành 2
         * dòng chữ chồng nhau. Cho camera tầng TRÊN bỏ qua nó ⇒ chỉ còn một dòng ở tầng dưới.
         */
        if (this.hudText) this.bandCam.ignore(this.hudText);
      }
      this.applyBand(this.bandCam, bands.top);
      /*
       * ⚠️ VẠCH CHIA + ĐỒNG HỒ KHÔNG CÒN Ở ĐÂY — chuyển sang HUD (`bandSeamHtml`/`paintBandSeam`)
       * trong lượt 02/10/2026: số đồng hồ nằm trong ẢNH CHỤP của HUD (`snapshot.seconds`/
       * `matchSeconds`) mà scene KHÔNG cầm ảnh chụp, nên scene chỉ vẽ được 2 nhãn chữ. Scene vẫn là
       * bên quyết định HÌNH HỌC (qua `arenaPortraitField()`), HUD chỉ thi hành toạ độ đó.
       */
      this.view?.resize();
    } finally {
      this.applyingLayout = false;
    }
  }

  /** Ghi viewport + zoom + scroll của MỘT tầng xuống camera Phaser (số đã tính ở hàm thuần). */
  private applyBand(cam: Phaser.Cameras.Scene2D.Camera, b: ArenaBandView): void {
    cam.setViewport(b.x, b.y, b.w, b.h);
    cam.setZoom(b.zoom);
    /* `setScroll` NHẬN toạ độ Phaser (không phải mép trái vùng nhìn) — xem `ArenaBandView.scrollX`. */
    cam.setScroll(b.scrollX, b.scrollY);
  }

  /**
   * GỠ CAMERA TẦNG TRÊN — **`cameras.remove()`**, KHÔNG `cam.destroy()`.
   *
   * ⚠️⚠️ BUG ĐÃ ĐO ĐƯỢC TRONG CHROME (02/10/2026) — ĐÚNG LỖI NGƯỜI DÙNG BÁO *"nút back sau khi confirm
   * ở chế độ arena chưa clear state"*:
   *
   * `BaseCamera.destroy()` (Phaser 4.2.1) CHỈ xoá nội bộ (matrix, renderList, `scene = null`…) chứ
   * **KHÔNG tự gỡ mình khỏi `CameraManager.cameras`**. Camera đã huỷ nằm lại trong danh sách ⇒ khung
   * hình sau, `CameraManager.render` gọi `camera.preRender()` → `this.matrix.applyITRS(…)` với
   * `matrix = null` ⇒ ném `TypeError: Cannot set properties of null (setting '4')`.
   *
   * SỐ ĐO THẬT: vào Arena (dọc 412×915) → bấm BACK → xác nhận "Thoát" → `pageerror` nêu trên; vào lại
   * Arena thì danh sách camera có 3 phần tử (main + camera đã huỷ + camera mới) thay vì 2.
   *
   * `CameraManager.remove(cam)` = `destroy()` **+ `cameras.splice()`** ⇒ state sạch. Đây là API đúng,
   * không phải "gọi thêm cho chắc".
   */
  private removeBandCamera(): void {
    const cam = this.bandCam;
    if (!cam) return;
    this.bandCam = null;
    this.cameras.remove(cam);
  }

  /**
   * ĐẶT CỠ CANVAS = `w×h` (tỉ lệ 1:1 với CSS px) — ĐƯỜNG DUY NHẤT ĐƯỢC PHÉP Ở KHỔ DỌC.
   *
   * ⚠️⚠️ PHASER 4 KHOÁ TỈ LỆ CỦA `displaySize` BẰNG `setAspectRatio` — ĐỌC KỸ, SỐ ĐO CÓ THẬT.
   *
   * `ScaleManager.resize(w, h)` đổi `gameSize`/ `baseSize`/ `canvas.width|height` nhưng **KHÔNG** cập nhật
   * `displaySize.aspectRatio` (chỉ `setGameSize()` mới làm, mà nó lại có bẫy riêng). Trong khi đó
   * `displaySize.aspectMode = FIT` nên MỌI `setSize` sau đó bị ÉP về tỉ lệ CŨ `1000/600`.
   *
   * SỐ ĐO THẬT KHI THIẾU DÒNG `setAspectRatio` (Chrome, khổ 412×915): `resize(412, 915)` cho
   * `canvas.width = 412 · canvas.height = 915` (thuộc tính) NHƯNG style vẫn
   * `width: 412px; height: 247,2px; margin-top: 333px` ⇒ canvas bị kéo về TỈ LỆ NGANG và nằm lệch xuống,
   * hai tầng không bao giờ vừa màn. Đây là loại lỗi "gọi đúng API mà sai ngầm" — nên phải ghim tỉ lệ
   * rồi `refresh()` để Phaser tính lại `displaySize` theo tỉ lệ MỚI.
   */
  private setCanvasGameSize(w: number, h: number): void {
    this.scale.resize(w, h);
    this.scale.displaySize.setAspectRatio(w / h);
    this.scale.refresh();
  }

  /**
   * HỆ SỐ PHÓNG ĐỘ PHÂN GIẢI CỦA CANVAS = `devicePixelRatio` (kẹp ≤ 3) — nguồn chung cho CẢ HAI khổ.
   *
   * ⚠️⚠️ SỬA LỖI NGƯỜI DÙNG: *"arena khi chơi màn hình ngang ảnh lại không nét"*. Trước lượt này chỉ
   * khổ DỌC nhân DPR (`applyArenaLayout`), còn `applyLandscapeLayout` đặt `baseSize` = cỡ thiết kế
   * 1000×600 ⇒ trên điện thoại DPR 2–3 trình duyệt PHÓNG TO bitmap lên 1,3–1,95 lần (desktop 1440×900
   * DPR 2: 2,88 lần) ⇒ nhoè. SỐ ĐO TRƯỚC KHI SỬA (Chrome, 844×390 DPR 2): canvas attr 1000×600 · CSS
   * 650×390 · physical 1300×780 ⇒ **phóng 1,30×**; cùng lúc khổ dọc 412×915 DPR 2 cho attr 824×1830 =
   * physical ⇒ **1,00×** (nét). Vì vậy gom về MỘT hàm: hai khổ lệch nhau chính là gốc của bug.
   *
   * 🔢 TRẦN 3: DPR điện thoại phổ biến 2–3; cao hơn chỉ tốn GPU mà mắt không thấy.
   */
  private renderScale(): number {
    return Math.min(3, Math.max(1, (typeof window !== 'undefined' && window.devicePixelRatio) || 1));
  }

  /**
   * HỆ SỐ PHÓNG ĐỘ PHÂN GIẢI CHO **KHỔ NGANG** = `fit × DPR`, KHÔNG phải chỉ `DPR` — ĐỌC KỸ VÌ ĐÂY LÀ
   * CHỖ TÔI ĐÃ SỬA HỤT MỘT LẦN (bản đầu chỉ dùng `DPR`, đo ra desktop 1440×900 DPR 2 VẪN nhoè 1,44×).
   *
   * VÌ SAO PHẢI CÓ `fit`: canvas nền phải bằng **cỡ CSS hiển thị × DPR** (đó mới là "1 điểm ảnh nền =
   * 1 điểm ảnh vật lý"). Mà cỡ CSS hiển thị của `Scale.FIT` là `cỡ thiết kế × fit`, với
   * `fit = min(containerW / 1000, containerH / 600)`. Cỡ thiết kế × DPR là CHƯA ĐỦ: trên màn 1440×900
   * `fit = 1,44` nên hiển thị 1440×864 CSS ⇒ cần 2880×1728 điểm ảnh nền, trong khi "thiết kế × DPR" chỉ
   * cho 2000×1200 ⇒ vẫn phải phóng 1,44×.
   *
   * 🔢 ĐO ĐƯỢC (Chrome, để đối chiếu khi sửa lại):
   * | khổ | fit | DPR | hệ số phóng đúng | canvas nền | CSS | physical |
   * |---|---|---|---|---|---|---|
   * | 844×390 (ngang đt) | 0,65 | 2 | **1,30** | 1300×780 | 650×390 | 1300×780 |
   * | 844×390 (ngang đt) | 0,65 | 3 | **1,95** | 1950×1170 | 650×390 | 1950×1170 |
   * | 844×390 | 0,65 | 1 | **0,65** | 650×390 | 650×390 | 650×390 |
   * | 1440×900 (desktop) | 1,44 | 2 | **2,88** | 2880×1728 | 1440×864 | 2880×1728 |
   * ⇒ CẢ 4 DÒNG ĐỀU RA `canvas nền = physical` (1:1, nét).
   *
   * ⚠️⚠️ VÌ SAO `fit` TÍNH ĐƯỢC MÀ KHÔNG VÒNG LẶP: `displaySize = baseSize × min(cw/baseW, ch/baseH)`;
   * thay `baseSize = thiết kế × s` thì `displaySize = thiết kế × min(cw/thiếtKế, ch/thiếtKế)` — **KHÔNG
   * phụ thuộc `s`**. Nên `fit` lấy từ khung chứa + cỡ thiết kế là chính xác, không cần đo lại sau.
   *
   * ⚠️ TRẦN DIỆN TÍCH NỀN: màn 4K DPR 2 mà không kẹp thì canvas nền = 7200×4320 (31 Mpx) — tốn GPU vô
   * ích. Kẹp theo DIỆN TÍCH (không kẹp theo bề ngang) để mọi tỉ lệ màn hình đều được lợi như nhau.
   * Khung chưa đo được (đang ẩn, `clientWidth < 2`) ⇒ lùi về `DPR`; `applyArenaLayout` sẽ chạy lại.
   */
  private landscapeRenderScale(): number {
    const canvas = typeof document !== 'undefined' ? document.querySelector<HTMLCanvasElement>('#arena canvas') : null;
    const host = canvas?.parentElement ?? (typeof document !== 'undefined' ? document.getElementById('arena') : null);
    /*
     * ⚠️ PHÉP TÍNH NẰM Ở `landscapeRenderScaleFor` (hàm THUẦN, `render/arena-camera.ts`) — ở đây chỉ
     * ĐO khung chứa rồi gọi. Lý do tách: đây là chỗ đã sửa hụt một lần (`fit × DPR` chứ không chỉ `DPR`),
     * nên nó phải có bài test bằng SỐ trong vitest chứ không chỉ đo được trên Chrome.
     */
    return landscapeRenderScaleFor(
      Math.round(host?.clientWidth ?? 0),
      Math.round(host?.clientHeight ?? 0),
      this.renderScale(),
    );
  }

  /** Bố cục khổ NGANG/ desktop — cũng là đường KHÔI PHỤC khi rời khổ dọc. */
  private applyLandscapeLayout(): void {
    /*
     * ⚠️ CỠ CANVAS Ở KHỔ NGANG = CỠ THIẾT KẾ × `landscapeRenderScale()` (canvas nền = physical px), và
     * camera đi kèm bằng `setRenderScale(s)`: zoom GHI XUỐNG PHASER = zoom thiết kế × s, viewport = cỡ
     * thiết kế × s ⇒ vùng world nhìn thấy KHÔNG ĐỔI (`viewport / zoom`), chỉ bitmap dày lên. Bố cục y
     * hệt trước (fit 1000×600 vào khung chứa), nên mọi phép đo layout/ cú chạm giữ nguyên giá trị.
     */
    const dpr = this.landscapeRenderScale();
    /*
     * ⚠️ ĐẶT LẠI CỜ CỘT AVATAR Ở CẢ HAI NHÁNH: `avatarColumns` chỉ có nghĩa khi `bands` != null (`null` =
     * khổ ngang), nhưng để cờ cũ nằm lại là mầm lỗi cho lần đọc sau — cùng loại "trạng thái mồ côi" mà
     * `teardownPortrait` phải dọn.
     */
    this.avatarColumns = false;
    /* ⚠️ `Math.round`: hệ số phóng là số thực (0,65 × 3 = 1,95) ⇒ canvas attr phải là SỐ NGUYÊN, không thì
     * `baseSize` lệch nửa px so với `canvas.width` và `displayScale` không còn đúng bằng hệ số phóng. */
    const wantW = Math.round(ARENA_CAMERA_VIEW.w * dpr);
    const wantH = Math.round(ARENA_CAMERA_VIEW.h * dpr);
    /*
     * ⚠️⚠️ NHÁNH NHANH PHẢI KIỂM **CẢ CỠ CANVAS**, KHÔNG CHỈ "có camera tầng hay không" — BUG ĐÃ SẬP
     * NGAY LẦN ĐO ĐẦU CỦA LƯỢT SỬA NÀY, GHI LẠI:
     * bản đầu tôi để điều kiện là `!this.bandCam && !this.bands` (đúng như code cũ) ⇒ lúc MỞ Arena
     * (chưa có camera tầng, `bands = null`) nó đi vào nhánh nhanh, mà nhánh đó CHỈ ghi viewport/zoom
     * ⇒ canvas vẫn 1000×600 của config trong khi viewport/zoom đã × DPR. Kết quả đo được: `cam.zoom = 2`
     * nhưng `canvas attr = 1000×600`, `baseSize = 1000×600` ⇒ **vẫn nhoè 1,30×**. Điều kiện đúng phải
     * là "canvas ĐÃ đúng cỡ × DPR chưa"; chưa thì rơi xuống nhánh đầy đủ để cấp lại.
     */
    const alreadyLandscape =
      !this.bandCam &&
      !this.bands &&
      Math.round(this.scale.baseSize.width) === wantW &&
      Math.round(this.scale.baseSize.height) === wantH;
    if (alreadyLandscape) {
      /* Đã đúng khổ ngang VÀ đúng độ phân giải: chỉ cần ép lại viewport (đường `resize` cũ). */
      this.cameras.main.setViewport(0, 0, wantW, wantH);
      this.cam.setRenderScale(dpr);
      this.cam.resize(ARENA_CAMERA_VIEW.w, ARENA_CAMERA_VIEW.h);
      this.view?.resize();
      return;
    }
    this.applyingLayout = true;
    try {
      /* ⚠️ `removeBandCamera()` chứ KHÔNG `destroy()` — xem chú thích dài ở hàm đó (bug TypeError). */
      this.removeBandCamera();
      this.bands = null;
      this.setCanvasGameSize(wantW, wantH);
      this.cameras.main.setViewport(0, 0, wantW, wantH);
      this.cam.setRenderScale(dpr);
      this.cam.resize(ARENA_CAMERA_VIEW.w, ARENA_CAMERA_VIEW.h);
      this.view?.resize();
    } finally {
      this.applyingLayout = false;
    }
  }

  /** Lắng nghe hướng màn hình + kích thước thanh trên/ dock (2 nguồn làm hình học 2 tầng đổi). */
  private setupPortraitWatch(): void {
    window.matchMedia(ARENA_PORTRAIT_MQ).addEventListener('change', this.onPortraitChange);
    this.installBandObserver();
  }

  private installBandObserver(): void {
    if (typeof ResizeObserver === 'undefined') return;
    this.bandObserver?.disconnect();
    this.bandObserver = new ResizeObserver(() => {
      if (this.disposed) return;
      if (window.matchMedia(ARENA_PORTRAIT_MQ).matches) this.applyArenaLayout();
    });
    /* HUD chèn thanh trên/ dock/ hàng avatar vào DOM muộn (lúc vào trận) ⇒ mỗi lần gọi TÌM LẠI. */
    for (const sel of ['.arena-hud-bar', '.arena-dock', '.arena-icon-layer']) {
      const el = document.querySelector(sel);
      if (el) this.bandObserver.observe(el);
    }
  }

  /**
   * GỠ KHỔ DỌC + **TRẢ CANVAS VỀ CỠ THIẾT KẾ** — gọi ở `SLEEP` (rời Arena) và `SHUTDOWN`.
   *
   * ⚠️ KHÔNG trả lại cỡ thiết kế là màn 10-wave/ trang chủ thừa hưởng canvas dọc ⇒ méo hình — mà
   * `Game.exitArena` chỉ `sleep()`, KHÔNG `stop()`, nên `dispose()` không chạy ở đường đó.
   */
  private teardownPortrait(): void {
    window.matchMedia(ARENA_PORTRAIT_MQ).removeEventListener('change', this.onPortraitChange);
    this.bandObserver?.disconnect();
    this.bandObserver = null;
    this.removeBandCamera();
    this.bands = null;
    /* Cùng lý do như `applyLandscapeLayout`: không để cờ "cột avatar" sống lẻ sau khi hết 2 tầng. */
    this.avatarColumns = false;
    /*
     * ⚠️ KHÔNG `return` KHI `this.disposed` Ở ĐÂY: `dispose()` GỌI HÀM NÀY SAU KHI đã bật cờ đó, mà
     * việc trả canvas về cỡ thiết kế thì vẫn PHẢI xảy ra (nếu không, màn sau thừa hưởng canvas dọc).
     * `scale.resize` phát sự kiện `resize` → `onScaleResize` tự bỏ qua vì `disposed` — không đệ quy.
     */
    this.applyingLayout = true;
    try {
      /*
       * ⚠️⚠️ TRẢ VỀ CỠ THIẾT KẾ **KHÔNG NHÂN DPR** — CỐ Ý, ĐỪNG "CHO ĐỒNG BỘ" VỚI KHỔ NGANG.
       * Hàm này chạy khi RỜI Arena (`SLEEP`/`SHUTDOWN`), lúc đó canvas bị màn khác dùng chung (trang
       * chủ, màn 10-wave). Màn 10-wave có đường cấp cỡ riêng (`game.resizeArena()`), nên để lại cỡ
       * thiết kế 1000×600 đúng như trước là hành vi đã được khoá bởi `verify:arena` — nhân DPR ở đây
       * là đổi cỡ canvas của MỘT màn khác, ngoài phạm vi sửa lỗi "arena ngang không nét".
       * Khi vào lại Arena, `applyArenaLayout`/ `applyLandscapeLayout` cấp lại cỡ × DPR.
       */
      this.setCanvasGameSize(ARENA_CAMERA_VIEW.w, ARENA_CAMERA_VIEW.h);
    } finally {
      this.applyingLayout = false;
    }
  }

  /** Rời Arena (scene `sleep`) ⇒ gỡ khổ dọc để màn khác không thừa hưởng. */
  private onArenaSleep(): void {
    this.teardownPortrait();
  }

  /** Quay lại Arena ⇒ cài lại khổ dọc theo hướng màn hình HIỆN TẠI (người chơi có thể đã xoay máy). */
  private onArenaWake(): void {
    if (this.disposed) return;
    this.setupPortraitWatch();
    this.applyArenaLayout();
  }

  /**
   * ÉP PHASER ĐO LẠI KÍCH THƯỚC — GỌI TỪ NGOÀI SAU KHI ĐỔI MÀN HÌNH.
   *
   * ⚠️ VÌ SAO CẦN HÀM NÀY (bẫy đã sập, xem `Hud.showScreen`): lúc boot `#home` đang hiện nên khung
   * chứa sân có kích thước 0×0 ⇒ Phaser dựng canvas 0×0 và KHÔNG tự đo lại (cửa sổ không đổi kích
   * thước). Vào trận thì khung đã có kích thước thật nhưng canvas vẫn 0×0 VĨNH VIỄN ⇒ sân trống và
   * MỌI CÚ BẤM KHÔNG ĂN.
   *
   * ⚠️ Ở KHỔ NGANG: KHÔNG gọi `scale.resize(w, h)` (xem `game.resizeArena()`), chỉ bảo Phaser đo lại.
   * Ở KHỔ DỌC thì `applyArenaLayout` CỐ Ý đổi `baseSize` sang cỡ khung chứa — kèm dựng lại camera, nên
   * hai hệ toạ độ vẫn là một (xem chú thích dài ở `applyArenaLayout`).
   */
  resizeView(): void {
    this.applyArenaLayout();
  }

  // ════════════════════════════════════════════════════════════════════════
  // GẮN TRẬN
  // ════════════════════════════════════════════════════════════════════════

  /**
   * GẮN MỘT TRẬN VÀO SCENE — gọi từ `Game` khi bắt đầu trận Arena.
   *
   * Vì sao scene KHÔNG tự dựng `ArenaWorld`: sim là tầng thuần, tất định, chạy được headless (nghìn
   * trận/giây cho công cụ cân bằng). Để scene tự `new ArenaWorld(...)` là buộc mọi công cụ đo phải
   * dựng cả Phaser. `Game` dựng world rồi giao vào — đúng như `ArenaScene.attachWorld` của game cũ.
   */
  attachWorld(world: ArenaWorld): void {
    this.unitAdapter.reset();
    /*
     * ⚠️ BÓNG PHẢI TẮT KHI VÀO TRẬN MỚI. Nếu không, một lần kéo dở rồi bấm "Về trang chủ"/ vào trận
     * khác sẽ để lại bóng nằm trên sân ở màn sau — người chơi thấy một tướng "ma" không bấm được.
     * (Scene `start()` chạy lại `create()` nên `ghost` được dựng lại; còn đường `wake()` thì KHÔNG —
     * đây chính là đường `wake()` mà `Game.startArena` dùng cho các trận sau.)
     */
    this.ghost?.hide();
    this.ghostClock = 0;
    /*
     * VỆT ĐẠN: xoá sạch khi VÀO TRẬN MỚI. Scene đi đường `sleep()`/ `wake()` (xem `Game.exitArena`) nên
     * `create()` KHÔNG chạy lại — không xoá thì các vệt đạn của trận TRƯỚC nằm nguyên trên sân trận sau
     * (chúng chỉ tự hết sau ~0,2s, nhưng hiện ra một khung hình "đạn ma" ngay lúc mở trận).
     */
    this.view?.clearShots();
    this.world = world;
    this.acc = 0;
    /*
     * ⚠️ VÀO TRẬN MỚI ⇒ ĐÓNG CỔNG BẮT ĐẦU LẠI (yêu cầu: mỗi lần vào Arena đều phải bấm `Bắt đầu` rồi
     * đếm lùi 3-2-1). `attachWorld` là đường DUY NHẤT tạo trận mới nên đặt cờ ở đây là đủ; quên chỗ này
     * thì trận thứ hai trở đi chạy NGAY, không có màn đếm lùi — lỗi chỉ lộ khi chơi lại lần hai.
     */
    this.arenaStarted = false;
    this.lastStatus = world.status;
    this.eventBuf = [];

    /*
     * CAMERA: người chơi LUÔN Ở MÉP TRÁI MÀN HÌNH khi PVE (yêu cầu người dùng).
     * `dt = 0` ⇒ đặt thẳng không làm mượt: lúc mở trận camera phải đứng sẵn ở đúng chỗ, không trượt
     * từ mép trái vào (trượt lúc mở trận làm người chơi tưởng sân đang rung).
     * Neo vào `x` Nhà MÌNH, không neo vào giữa sân — xem `PLAYER_SCREEN_ANCHOR` ở `arena-camera.ts`.
     *
     * ⚠️ Ở KHỔ DỌC THÌ KHÔNG (xem `applyArenaLayout`): hai camera đứng YÊN, mỗi cái khoá vào một nửa
     * sân — gọi `followSide` ở đây sẽ ghi đè zoom/ scroll của tầng dưới và làm sân lệch.
     */
    this.applyArenaLayout();
    if (!this.bands) {
      this.cam.followSide('left', world.cores.left.x, 0);
      // canh giữa theo chiều dọc để thấy TRỌN chiều cao sân (sông chạy suốt + 2 cầu trên/ dưới)
      this.cam.centerY(ARENA_WORLD.h / 2);
    }
    /* HUD có thể vừa chèn thanh trên/ dock ⇒ bám lại kích thước của chúng cho khổ dọc. */
    this.installBandObserver();
    /*
     * ⚠️ ĐO LẠI MỘT LẦN SAU KHI HUD VẼ XONG (400ms) — LỖI ĐÃ ĐO ĐƯỢC, ĐỪNG BỎ.
     * Lúc `attachWorld` chạy, HUD chưa chắc đã dựng xong HÀNG AVATAR (avatar do `render()` của HUD sinh
     * ra ở khung hình đầu). Nếu chia 2 tầng ngay lúc đó thì `insetBottom` chỉ tính `.arena-dock` (60px)
     * mà bỏ hàng avatar (ở y≈800) ⇒ tầng DƯỚI bị avatar đè. Đo lại sau 400ms là đủ để HUD ổn định, và
     * đây là đường DUY NHẤT bắt được ca đó (avatar đổi VỊ TRÍ, không đổi kích thước ⇒ ResizeObserver im).
     */
    this.time.delayedCall(400, () => {
      if (!this.disposed) this.applyArenaLayout();
    });
    // vẽ lại nền theo cỡ vùng nhìn hiện tại
    this.view.resize();
  }

  /**
   * MỞ CỔNG BẮT ĐẦU — HUD gọi SAU khi đếm lùi 3-2-1 hiện xong (xem `arenaStarted` và `ArenaHud`).
   *
   * ⚠️ `acc = 0`: trong lúc chờ, vòng lặp bị chặn nên `acc` không được cộng; đặt lại 0 là để chắc chắn
   * không có phần thời gian nào tích từ trước được "tua bù" thành một loạt tick ngay khi vừa bấm.
   * ⚠️ Idempotent: HUD có thể gọi lại (bấm `Bắt đầu` lần hai trong lúc đếm) — gọi lại là vô hại.
   */
  startArenaNow(): void {
    this.arenaStarted = true;
    this.acc = 0;
  }

  /**
   * XOÁ TRẠNG THÁI TRẬN KHỎI SCENE — `Game.exitArena()` gọi khi rời màn.
   *
   * Yêu cầu người dùng 02/10/2026: *"Khi chiến thắng hiển thị nút thoát trên thông báo đó nữa nhé, khi
   * thoát thì ra màn hình chính và clear state"*.
   *
   * ⚠️⚠️ VÌ SAO CẦN HÀM NÀY DÙ `attachWorld` SẼ THAY WORLD Ở TRẬN SAU: giữa hai trận, scene chỉ
   * `sleep()` (KHÔNG `stop()` — xem `Game.exitArena`), nên `this.world` vẫn trỏ vào trận VỪA XONG. Mọi
   * đường đọc trạng thái trong lúc ở trang chủ (HUD ẩn, công cụ kiểm chứng, `onExit` hỏi "còn đang
   * chơi không") sẽ thấy một trận đã kết thúc mà tưởng là đang chơi. Xoá ở đây làm trạng thái "đã rời
   * màn" đọc ra ĐÚNG, và buộc trận sau phải `attachWorld` lại từ đầu.
   *
   * ⚠️ KHÔNG xoá tiến trình trong save (`ArenaProgress`): số trận/ thưởng/ mỏ đã nâng là THÀNH TỰU phải
   * giữ; "clear state" ở đây là trạng thái PHIÊN CHƠI (world · cổng bắt đầu · bóng · vệt đạn).
   * ⚠️ `update()` đã có guard `if (!w) return` nên scene ngủ với `world = null` là an toàn; `wake()` +
   * `attachWorld(newWorld)` ở `startArenaFromHome` mới dựng lại trận.
   */
  clearWorld(): void {
    this.world = null;
    this.arenaStarted = false;
    this.acc = 0;
    this.lastStatus = 'prep';
    this.eventBuf = [];
    /*
     * BÓNG là hình vẽ của SCENE (không nằm trong HUD) nên `hud.hide()` không che nó — phải tự tắt, cùng
     * lý do đã ghi ở `attachWorld`. Vệt đạn cũng vậy (chúng sống vài trăm ms).
     */
    this.ghost?.hide();
    this.view?.clearShots();
  }

  // ════════════════════════════════════════════════════════════════════════
  // QUY ĐỔI TOẠ ĐỘ MÀN HÌNH → THẾ GIỚI (CỬA VÀO CHO HUD KÉO-THẢ AVATAR)
  // ════════════════════════════════════════════════════════════════════════

  /**
   * TOẠ ĐỘ **CLIENT** CỦA PointerEvent → TOẠ ĐỘ THẾ GIỚI 1000×600.
   *
   * ⚠️⚠️ ĐÂY LÀ ĐƯỜNG QUY ĐỔI **DUY NHẤT** ĐƯỢC PHÉP — QUYẾT ĐỊNH #1 Ở ĐẦU FILE.
   * HUD là DOM nên nó chỉ có `event.clientX/clientY`; scene là Phaser nên nó có `cameras.main`
   * (nguồn THẬT SỰ đang vẽ). HUD **KHÔNG được** tự viết công thức quy đổi: repo đã sập một lần vì
   * hai đường tính toạ độ lệch nhau ("bấm giữa sân ra orderX 787 thay vì ~500"), và ở API mới bẫy
   * này còn nặng hơn vì toạ độ thả được dùng TRỰC TIẾP làm vị trí xuất quân.
   *
   * ⚠️ VÌ SAO PHẢI QUA `this.scale.transformX/Y` TRƯỚC KHI `getWorldPoint`:
   * `getWorldPoint(x, y)` nhận toạ độ trong KHÔNG GIAN CANVAS (đúng thứ Phaser đưa vào `pointer.x`),
   * không phải toạ độ client. Với `Scale.FIT` + canvas canh giữa, canvas có thể bị DỜI và CO so với
   * khung nhìn, nên đưa thẳng `clientX` vào là lệch (và lệch theo tỉ lệ màn hình ⇒ sai kiểu rất khó
   * truy). `scale.transformX/Y` chính là hàm Phaser dùng NỘI BỘ khi dựng `pointer.x/y`
   * (`InputManager`: `this.scaleManager.transformX(pageX)`) ⇒ đi qua nó là đi ĐÚNG đường của Phaser,
   * không phải công thức tự chế. Ở đây KHÔNG trừ tay `canvasBounds.left` lần nào.
   */
  worldFromScreen(clientX: number, clientY: number): { x: number; y: number } {
    /*
     * Bảo vệ 2 ca hỏng: (a) scene đã dispose, (b) `canvasBounds` chưa đo (0×0 lúc boot, xem
     * `onScaleResize`) ⇒ `transformX/Y` sẽ trả `Infinity`/ `NaN`. Trả toạ độ hữu hạn (0,0) để HUD
     * nhận `ok:false` từ sim (toạ độ ngoài sân) thay vì nhận `NaN` chảy vào vị trí unit.
     */
    if (this.disposed) return { x: 0, y: 0 };
    const sx = this.scale.transformX(clientX);
    const sy = this.scale.transformY(clientY);
    if (!Number.isFinite(sx) || !Number.isFinite(sy)) return { x: 0, y: 0 };
    /*
     * ⚠️⚠️ KHỔ DỌC: PHẢI CHỌN CAMERA THEO TẦNG CON TRỎ ĐANG Ở — ĐÂY LÀ CHỖ DỄ SAI NHẤT CỦA 2 TẦNG.
     *
     * Mỗi tầng là MỘT camera riêng (`makeArenaPortraitBands`), nên cùng một toạ độ canvas cho ra hai
     * toạ độ world KHÁC NHAU tuỳ tầng. Dùng nhầm camera (hoặc luôn dùng `cameras.main`) thì kéo-thả ở
     * tầng TRÊN sẽ ra toạ độ của nửa sân MÌNH — tướng ra sai chỗ, hoặc bị luật `isValidDeployPos` từ
     * chối (nửa sân địch) ⇒ người chơi thấy "tầng trên không thả được gì".
     *
     * `pickArenaBand` chỉ so với đường chia 2 tầng; con trỏ nằm trong THANH TRÊN/ DOCK thì rơi vào
     * tầng gần nhất, và `isValidDeployPos` sẽ từ chối vì toạ độ world rơi ra ngoài sân (y < 0 hoặc
     * y > 600) — đúng ý: kéo vào vùng chrome thì KHÔNG thả được.
     */
    if (this.bands) {
      const cam = pickArenaBand(this.bands, sy) === 'top' ? this.bandCam : this.cameras.main;
      if (!cam) return { x: 0, y: 0 };
      const q = cam.getWorldPoint(sx, sy);
      return { x: q.x, y: q.y };
    }
    const p = this.cameras.main.getWorldPoint(sx, sy);
    return { x: p.x, y: p.y };
  }

  /**
   * HÌNH HỌC KHỔ DỌC CHO HUD — hợp đồng để HUD đặt avatar vào ĐÚNG dải trống hai bên sân.
   *
   * ⚠️⚠️ VÌ SAO SCENE PHẢI PHÁT SỐ NÀY CHỨ HUD KHÔNG TỰ ĐO: dải trống KHÔNG nằm trong DOM. Ở khổ dọc,
   * `#arena canvas` phủ KÍN khung nhìn (412×915); chỗ trống là do hai CAMERA của Phaser có viewport hẹp
   * hơn canvas (`makeArenaPortraitBands` canh giữa sân). HUD đo `getBoundingClientRect()` của canvas sẽ
   * luôn ra `left = 0` ⇒ tưởng "không có dải" ⇒ xếp avatar thành HÀNG NGANG ĐÈ LÊN SÂN. Chỉ scene biết
   * `bands.top.x` / `bands.top.w`. Đây đúng tinh thần quyết định #1 của `ArenaHudHost`: hai đường tính
   * toạ độ là hai nguồn sự thật.
   *
   * ⚠️ `avatarColumns = false` KHÔNG có nghĩa "khổ ngang": nó là màn dọc quá cao/ hẹp mà fit chiều cao
   * làm `zoom` bị chặn bởi bề ngang (hết dải trống) ⇒ scene đã chừa chỗ cho HÀNG NGANG và HUD phải xếp
   * hàng. Vì vậy HUD dùng `avatarColumns` để quyết định, KHÔNG tự đo lại (lệch ngưỡng là avatar đè sân).
   *
   * ⚠️ Trả về `null` khi KHÔNG ở khổ dọc 2 tầng (khổ ngang/ desktop giữ nguyên hành vi cũ).
   */
  arenaPortraitField(): { left: number; right: number; avatarColumns: boolean; splitY: number } | null {
    const b = this.bands;
    if (!b) return null;
    return {
      left: b.top.x / this.bandDpr,
      right: (b.top.x + b.top.w) / this.bandDpr,
      avatarColumns: this.avatarColumns,
      /*
       * ĐƯỜNG CHIA 2 TẦNG (px CSS) — HUD dùng để DỒN CỘT AVATAR VÀO NỬA DƯỚI màn hình (yêu cầu người
       * dùng: *"Đối với màn hình dọc, 6 avatar dọc theo 1/2 màn bên dưới"*): nửa dưới là SÂN MÌNH, nên
       * avatar nằm cạnh đúng nửa sân mà người chơi thả quân xuống. Xem `blockedRects` (HUD).
       */
      splitY: b.splitY / this.bandDpr,
    };
  }

  // ════════════════════════════════════════════════════════════════════════
  // LỆNH NGƯỜI CHƠI — thả quân ở TOẠ ĐỘ TỰ CHỌN
  // ════════════════════════════════════════════════════════════════════════

  /**
   * TRIỆU HỒI TƯỚNG Ở TOẠ ĐỘ NGƯỜI CHƠI CHỌN — câu của người dùng: *"tap vào avatar mua tướng để
   * mua tướng và tướng chạy ra ngay từ nhà hoặc kéo avatar đến vị trí nào tôi muốn ... tướng sẽ xuất
   * hiện ở đó"* + *"thả sai thì huỷ, báo lỗi"*.
   *
   * ⚠️ SCENE **KHÔNG** KIỂM LUẬT VỊ TRÍ — cố ý. Luật "toạ độ hợp lệ" nằm ở `sim/arena/deploy-pos.ts`
   * và được sim áp trong `summonHero` (đã có test riêng). Chép lại vài dòng `if` ở đây là có HAI bản
   * luật, và bản chạy trong game sẽ là bản KHÔNG được test — đúng loại "test xanh mà game sai".
   * `ok:false` từ sim ⇒ scene chỉ đẩy sự kiện lỗi cho HUD hiện toast, KHÔNG tự diễn giải thêm.
   */
  summonHero(classId: ClassId, x: number, y: number): { ok: boolean; message: string } {
    const w = this.world as ArenaSceneWorld | null;
    if (!w) return { ok: false, message: t('Chưa vào trận Arena', 'Not in an Arena match yet') };
    const res = w.summonHero(classId, x, y);
    if (!res.ok) this.emitEvent({ type: 'error' });
    return res;
  }

  /**
   * MUA NÔNG DÂN Ở TOẠ ĐỘ TỰ CHỌN (cùng luật toạ độ với `summonHero`).
   *
   * ⚠️ `autoMine` — CHUYỂN TIẾP Ý ĐỊNH CỦA CỬ CHỈ, KHÔNG TỰ CHỌN MỎ Ở ĐÂY: `true` khi HUD gọi từ
   * cú BẤM avatar (`tapIconCommand` — "nông dân ra ở Nhà rồi tự tìm mỏ ưng"), bỏ trống khi gọi từ
   * KÉO-THẢ (`dropCommand` — nông dân đi mỏ gần ĐIỂM THẢ). Luật chọn mỏ vẫn nằm một chỗ ở sim
   * (`ArenaWorld.preferredMine`), scene chỉ chuyển tham số — không chép luật sang tầng Phaser.
   */
  buyFarmer(x: number, y: number, autoMine = false): { ok: boolean; message: string } {
    const w = this.world as ArenaSceneWorld | null;
    if (!w) return { ok: false, message: t('Chưa vào trận Arena', 'Not in an Arena match yet') };
    const res = w.buyFarmer(x, y, autoMine);
    if (!res.ok) this.emitEvent({ type: 'error' });
    return res;
  }

  // ════════════════════════════════════════════════════════════════════════
  // BÓNG XEM TRƯỚC KHI KÉO-THẢ AVATAR MUA QUÂN (task-8 · task-9)
  // ════════════════════════════════════════════════════════════════════════

  /**
   * HIỆN BÓNG XEM TRƯỚC ("full hình nhân vật", idle, hơi mờ) Ở `(x, y)` THẾ GIỚI 1000×600.
   *
   * Yêu cầu người dùng (nguyên văn): *"khi kéo nhân vật vào chỗ có thể triệu hồi sẽ hiển thị full hình
   * nhân vật đó (trạng thái idle, hơi mờ mờ) để tôi ướm thử vị trí thả, khi tôi thả tay nhân vậy mới
   * được triệu hồi."* ⇒ bóng là HÌNH ẢNH THUẦN: không vào `world.units`, không va chạm, không điểm.
   *
   * ⚠️⚠️ CHỮ KÝ LÀ HỢP ĐỒNG VỚI `ArenaHudHost` (`src/ui/hud-arena.ts`): HUD gọi LIÊN TỤC trong
   * `pointermove` với toạ độ ĐÃ quy đổi qua `worldFromScreen`. Đổi tên/ tham số ở đây là `tsc` đỏ ở
   * `src/ui`/ `src/game.ts` — hai bên phải khớp CHÍNH XÁC.
   *
   * ⚠️ `kind` nhận CẢ `'farmer'` (task-9): người chơi kéo avatar NÔNG DÂN y như kéo tướng, nên nông
   * dân phải có bóng. Kiểu RỘNG HƠN này vẫn TƯƠNG THÍCH NGƯỢC với interface hiện tại của HUD (nó khai
   * `classId: ClassId`, là tập con) ⇒ `tsc` không đỏ; HUD chỉ cần đổi tham số truyền vào khi Lead nối.
   *
   * ⚠️⚠️ CHỈ HIỆN Ở CHỖ THẢ ĐƯỢC — và luật đó KHÔNG được chép lại ở đây. Dùng thẳng
   * `isValidDeployPos(x, y, DEPLOY_MARGIN)`: cùng hàm, cùng bán kính mà `ArenaWorld.summonHero` dùng
   * để phán quyết. Nhờ vậy bóng hiện ra ⇔ thả tay sẽ thành công, không có khe lệch nào giữa hai bên.
   * (Kéo xuống sông/ nửa sân địch/ ngoài mép/ vào thân Nhà ⇒ `hideDeployGhost()` — KHÔNG có bóng.)
   *
   * ⚠️ NÔNG DÂN DÙNG CÙNG `DEPLOY_MARGIN` VỚI TƯỚNG (dù bán kính va chạm của nó nhỏ hơn): HUD cũng
   * đang gate bằng chính hằng số đó (xem `updateDeployGhost`), nên hai tầng nói CÙNG một luật. Đổi
   * riêng cho nông dân ở đây là tạo bản luật thứ hai chỉ lệch vài pixel ở mép sân — không đáng.
   *
   * ⚠️ KHÔNG TỰ KIỂM TIỀN/ TRẠNG THÁI TRẬN: bóng là phản hồi vị trí, còn "đủ tiền chưa" do sim trả
   * qua toast lúc thả. Thêm điều kiện thứ hai ở đây là mở đường cho bóng và lệnh nói hai chuyện khác.
   *
   * ⚠️ RẺ: gọi lại với cùng đơn vị chỉ dời chỗ (xem `ArenaDeployGhost.show`). Không cấp phát mỗi lần gọi.
   */
  showDeployGhost(kind: UnitArtKind, x: number, y: number): void {
    if (this.disposed) return;
    // chưa có trận (HUD còn giữ thao tác cũ) ⇒ không vẽ gì, tránh bóng trên sân trống
    if (!this.world) {
      this.hideDeployGhost();
      return;
    }
    if (!isValidDeployPos(x, y, DEPLOY_MARGIN).ok) {
      this.hideDeployGhost();
      return;
    }
    this.ghost?.show(kind, x, y);
  }

  /**
   * TẮT BÓNG XEM TRƯỚC — gọi khi NHẢ TAY, khi huỷ thao tác kéo, và khi vào trận mới.
   *
   * ⚠️ AN TOÀN KHI CHƯA TỪNG HIỆN và khi gọi 2 lần liên tiếp (hợp đồng trong task): `hide()` chỉ lật
   * cờ rồi `setVisible(false)` trên danh sách sprite — danh sách rỗng thì không làm gì và KHÔNG ném.
   */
  hideDeployGhost(): void {
    this.ghost?.hide();
  }

  /** DANH SÁCH TƯỚNG CÓ THỂ MUA — HUD đọc để dựng nút. Giá lấy từ `data/arena.ts`, KHÔNG hard-code. */
  heroOptions(heroClasses: readonly ClassId[]): ArenaHeroOption[] {
    return heroClasses.map((classId) => ({ classId, cost: arenaHeroCost(classId) }));
  }

  /** Giá 1 tướng — tiện cho HUD/ test. Không chép số: đi qua `data/arena.ts`. */
  heroCost(classId: ClassId): number {
    return ARENA_HERO_COST[classId] ?? arenaHeroCost(classId);
  }

  // ════════════════════════════════════════════════════════════════════════
  // SỰ KIỆN RA NGOÀI
  // ════════════════════════════════════════════════════════════════════════

  /**
   * ĐỆM MỘT SỰ KIỆN ĐỂ `update` PHÁT RA NGOÀI Ở NHỊP ỔN ĐỊNH.
   *
   * ⚠️ VÌ SAO KHÔNG GỌI HOOK NGAY TẠI ĐÂY: sự kiện có thể tới từ LỆNH UI (`summonHero` gọi từ HUD,
   * không phải từ `update`). Gọi hook ngay thì HUD nhận sự kiện ở một nhịp khác với phần còn lại của
   * khung hình, và trong lúc scene đang shutdown thì hook vẫn bắn (HUD đã bị dỡ ⇒ lỗi khó tái hiện).
   * Đệm lại rồi phát trong `update` ⇒ một nhịp duy nhất, và `dispose` xoá được đệm.
   */
  private emitEvent(e: ArenaSimEvent): void {
    if (this.disposed) return;
    this.eventBuf.push(e);
  }

  // ════════════════════════════════════════════════════════════════════════
  // VÒNG LẶP
  // ════════════════════════════════════════════════════════════════════════

  /**
   * MỘT KHUNG HÌNH.
   *
   * ⚠️⚠️ VÒNG LẶP TICK BẮT CHƯỚC **CHÍNH XÁC** `src/scenes/arena-scene.ts` — BỐN THÀNH PHẦN LÀ MỘT KHỐI.
   * `tests/arena-input.test.ts` KHOÁ CẢ BỐN bằng regex trên chính file này, vì thiếu một cái là hỏng
   * theo cách chỉ lộ ra khi game chạy thật:
   *   · `this.acc += realDt * speed`   — tua được (`speed > 1`) mà nhịp mô phỏng không đổi.
   *   · `while (this.acc >= DT …)`     — bước CỐ ĐỊNH 30Hz ⇒ mô phỏng KHÔNG phụ thuộc FPS. Ở màn
   *                                      120Hz, dùng `dt` thật cho sim là game chạy nhanh gấp đôi.
   *   · `steps < 12`                    — trần số bước mỗi khung hình.
   *   · `if (steps >= 12) this.acc = 0` — CHỐT CHỐNG SPIRAL-OF-DEATH. Máy chậm ⇒ mỗi khung hình phải
   *                                      chạy nhiều bước ⇒ khung hình càng dài ⇒ càng nhiều bước…
   *                                      vòng xoáy làm treo hẳn. Chốt này cắt vòng xoáy: thà bỏ bớt
   *                                      thời gian mô phỏng còn hơn treo game.
   *   · `hitStop`                       — ĐỨNG HÌNH VA CHẠM: đòn nặng thì mô phỏng khựng vài chục ms
   *                                      để cú đánh "có sức nặng". Sim chỉ ĐẶT cờ, việc khựng nằm ở
   *                                      lớp hiển thị nên sim vẫn tất định.
   *
   * ⚠️ `realDt` bị kẹp `<= 0.1` (100ms): khung hình đầu tiên sau khi tab bị ẩn có thể là vài giây;
   * không kẹp thì `acc` nhảy vọt và ta "tua" cả trận trong một khung hình.
   */
  update(_time: number, deltaMs: number): void {
    if (this.disposed) return;
    const w = this.world as ArenaSceneWorld | null;
    if (!w) return;

    const realDt = Math.min(0.1, deltaMs / 1000);

    /*
     * ⚠️⚠️ CỔNG BẮT ĐẦU — ĐỌC `arenaStarted` TRƯỚC KHI SỬA. Yêu cầu người dùng: *"tôi phải click Bắt
     * đầu, sẽ đếm lùi 3s … thì lúc đó game mới bắt đầu"*.
     *
     * Chưa mở cổng ⇒ KHÔNG tick sim: đồng hồ trận đứng ở 0:00, quân hai phe đứng yên, quái chưa ra.
     * Phần DƯỚI hàm (camera follow + vẽ) vẫn chạy ⇒ sân vẫn "sống" trong lúc chờ, không phải màn hình
     * đóng băng. HUD là nơi chạy đếm lùi và gọi `startArenaNow()` khi xong.
     */
    if (!this.paused && this.arenaStarted) {
      // ĐỨNG HÌNH VA CHẠM (hit-stop) — xem chú thích đầu hàm
      if ((w.hitStop ?? 0) > 0) {
        w.hitStop = Math.max(0, (w.hitStop ?? 0) - realDt);
      } else {
        // BƯỚC CỐ ĐỊNH 30Hz — mô phỏng không phụ thuộc FPS.
        // ⚠️ `arenaTimeSpeedMul(w.time, w.matchDuration)`: TUA THEO MỐC TRẬN (×2 từ phút 1, ×3 từ PHÚT 3,
        // **×5 ở 10 giây cuối** — yêu cầu người dùng). Nhân vào ĐÂY là nhân vào nhịp THỰC, KHÔNG đổi
        // `world.time`/ hồi chiêu ⇒ mọi phép cân bằng và trận 300 giây giữ nguyên — xem `ARENA_SPEED_RAMP`.
        // ⚠️ PHẢI truyền `matchDuration`: thiếu tham số thứ hai thì `arenaTimeSpeedMul` KHÔNG áp cửa sổ cuối.
        this.acc += realDt * this.speed * arenaTimeSpeedMul(w.time, w.matchDuration);
        let steps = 0;
        while (this.acc >= DT && steps < 12) {
          w.update(DT);
          this.acc -= DT;
          steps++;
        }
        if (steps >= 12) this.acc = 0; // tránh spiral of death
      }
    }

    /*
     * ⚠️ CAMERA CHẠY MỖI KHUNG HÌNH, KỂ CẢ KHI TẠM DỪNG.
     * Camera đuổi theo Nhà mình bằng hàm mũ (`approach`), nên nếu chỉ cập nhật khi sim chạy thì khi
     * tạm dừng camera cũng đứng — mà người chơi vẫn cần thấy sân đã cuộn tới đâu. Dùng `realDt` của
     * khung hình THẬT (không phải `DT`): làm mượt theo `DT` cứng sẽ bám nhanh gấp đôi ở màn 120Hz.
     *
     * ⚠️⚠️ Ở KHỔ DỌC THÌ **KHÔNG** — VÀ ĐÂY LÀ LỖI ĐÃ ĐO ĐƯỢC, ĐỪNG BỎ ĐIỀU KIỆN NÀY.
     * `followSide` ghi `setZoom` + `centerOn` xuống `cameras.main` theo hình học KHỔ NGANG (`viewW`
     * = 1000) — chạy nó ở khổ dọc là mỗi khung hình ghi đè zoom 0,63 về **1** và kéo camera về giữa
     * thế giới. SỐ ĐO THẬT khi thiếu điều kiện này: camera chính `zoom = 1`, `scrollX = 342,19`
     * (thay vì 0,63125 và 92,19) ⇒ tầng DƯỚI hiển thị sai nửa sân, còn `worldFromScreen` trả
     * `(500, 862)` cho tâm tầng dưới (đúng phải là `(250, 300)`).
     * Ở khổ dọc, mỗi tầng là một khung NHÌN CỐ ĐỊNH vào nửa sân của nó — không có gì để "đuổi theo".
     */
    if (!this.bands) this.cam.followSide('left', w.cores.left.x, realDt);

    // ĐẨY SỰ KIỆN RA UI — gom cả sự kiện của sim lẫn sự kiện do lệnh UI đệm vào
    const simEvents = w.events ?? [];
    if (simEvents.length) {
      for (const e of simEvents) this.emitEvent(e);
      simEvents.length = 0;
    }
    if (this.eventBuf.length) {
      for (const e of this.eventBuf) this.hooks.onWorldEvent?.(e);
      this.eventBuf = [];
    }

    // TRẠNG THÁI TRẬN: chỉ phát khi ĐỔI, và cập nhật `lastStatus` TRƯỚC khi gọi hook
    // (nếu hook ném lỗi thì trạng thái vẫn đã được chốt ⇒ không phát lại hai lần)
    if (w.status !== this.lastStatus) {
      this.lastStatus = w.status;
      this.hooks.onStatusChange?.(w.status);
    }

    // VẼ
    /*
     * VỆT ĐẠN (task-11, phần 2) — LẤY HÀNG ĐỢI PHÁT BẮN TỪ SIM RỒI ĐƯA XUỐNG LỚP VẼ.
     *
     * ⚠️ VÌ SAO Ở SCENE CHỨ KHÔNG PHẢI TRONG `view.update`: `drainShots()` là lệnh có TÁC DỤNG PHỤ
     * (rỗng hoá hàng đợi), còn `view.update` chỉ nhận dữ liệu ĐỌC. Scene đã làm đúng vai này với
     * `drainCastFx` (xem `drawSkillFx`) nên ở đây giữ nguyên phân vai: sim phát → scene chuyển → lớp vẽ vẽ.
     *
     * ⚠️ `?.()` BẮT BUỘC: hợp đồng đang được `sim-fix` cài; chưa có thì không vệt đạn và KHÔNG vỡ.
     */
    const shots = w.drainShots?.();
    if (shots?.length) this.view.addShots(shots);
    /*
     * ⚠️ KHỔ DỌC: HAI TẦNG CỘNG LẠI LÀ TRỌN THẾ GIỚI (0→500 ∪ 500→1000) ⇒ đưa `scrollX = 0` và
     * `viewW = 1000` để lớp vẽ KHÔNG cull gì. Truyền `this.cam.geometry.scrollX` (số của khổ ngang,
     * lúc này đã cũ) sẽ cull mất mỏ ở nửa sân kia — mỏ biến mất khỏi tầng đang nhìn.
     */
    const cullScrollX = this.bands ? 0 : this.cam.geometry.scrollX;
    const cullViewW = this.bands ? ARENA_WORLD.w : ARENA_CAMERA_VIEW.w;
    this.view.update(w as unknown as ArenaWorld, cullScrollX, cullViewW, realDt);
    /*
     * HIỆU ỨNG ULTIMATE THEO ẢNH (máy bay · bom xăng · vùng cháy) — đọc thẳng `arenaUltVisuals`/
     * `fireZonesActive` của sim, KHÔNG tự đoán thời điểm (xem `render/arena-ult-fx.ts`).
     */
    this.ultFx.sync(w, realDt);
    /*
     * ⚠️ KHÔNG ép kiểu ở đây: `ArenaSceneWorld extends ArenaWorldLike` và adapter nhận
     * `ArenaWorldLike`, nên `w` khớp TRỰC TIẾP. Trước đây dòng này là `w as unknown as ArenaWorld` —
     * một ép kiểu THỪA (vế trái nhận kiểu hẹp hơn), tức nó không che lỗi gì nhưng lại dạy người đọc
     * rằng chỗ này cần ép. Bỏ đi để phép kiểm của `tsc` có hiệu lực thật.
     */
    this.unitAdapter.sync(realDt, w);
    /*
     * BÓNG XEM TRƯỚC — cập nhật dáng idle + vị trí mỗi khung hình (chỉ khi đang hiện, xem
     * `ArenaDeployGhost.update`). Đồng hồ dùng `realDt` của khung hình THẬT chứ KHÔNG dùng `w.time`:
     * `world.time` đứng yên khi tạm dừng, và một bóng "đông cứng" trong lúc người chơi vẫn đang kéo
     * đọc ra như hình bị treo. Bóng không phải mô phỏng nên nó không có lý do gì dừng theo sim.
     */
    this.ghostClock += realDt;
    this.ghost?.update(this.ghostClock);
    this.drawSkillFx(w, realDt);
    this.drawDebugText(w);
  }

  /**
   * VẼ HIỆU ỨNG CHIÊU — SỬA LỖI "TƯỚNG DÙNG CHIÊU MÀ KHÔNG AI THẤY".
   *
   * ⚠️⚠️ NGƯỜI DÙNG BÁO: *"tướng tôi không thấy dùng skill (có lẽ do không có hiệu ứng hay đường
   * đạn)"*. Đo được: chiêu CÓ chạy và sát thương CÓ vào, nhưng màn hình không đổi gì ⇒ với người
   * chơi thì "không có gì xảy ra". Đây là lỗi TRÌNH BÀY, không phải lỗi luật.
   *
   * Nay: mỗi lần niệm chiêu, sim đẩy một mục vào `world.castFx` (xem `ArenaWorld.castFx`); ở đây
   * dựng HIỆU ỨNG 2 lớp theo màu PHE:
   *   · VÒNG LAN rộng dần tới `radius` của chiêu (với chiêu nổ quanh người) — đọc ra "chiêu đánh vào
   *     vùng này";
   *   · CHỚP SÁNG ở tâm rồi tắt — đọc ra "vừa có đòn bung ra".
   * Màu: XANH cho phe ta, ĐỎ cho phe địch — CÙNG hệ màu với vòng dấu phe dưới chân, nên mắt chỉ phải
   * học một quy ước.
   */
  private drawSkillFx(w: ArenaSceneWorld, realDt: number): void {
    const g = this.fxGfx;
    if (!g) return;
    g.clear();

    // nạp hiệu ứng MỚI do sim phát trong khung hình này
    for (const c of w.drainCastFx?.() ?? []) {
      this.fxActive.push({ x: c.x, y: c.y, radius: c.radius, side: c.side, t: 0, life: 0.45, skillId: c.skillId });
    }

    const alive: typeof this.fxActive = [];
    for (const fx of this.fxActive) {
      fx.t += realDt;
      if (fx.t >= fx.life) continue; // hết vòng đời ⇒ bỏ (không vẽ nữa)
      const k = fx.t / fx.life; // 0 → 1
      const color = fx.side === 'left' ? 0x7dd3fc : 0xfca5a5;
      // vòng lan: bán kính tối thiểu để chiêu đơn mục tiêu vẫn thấy được
      const r = Math.max(fx.radius, arenaDist(40)) * (0.35 + 0.65 * k);
      g.lineStyle(arenaDist(6) * (1 - k * 0.5), color, 0.85 * (1 - k));
      g.strokeCircle(fx.x, fx.y, r);
      // chớp sáng ở tâm — tắt nhanh hơn vòng
      if (k < 0.4) {
        g.fillStyle(0xffffff, 0.5 * (1 - k / 0.4));
        g.fillCircle(fx.x, fx.y, arenaDist(26));
      }
      alive.push(fx);
    }
    this.fxActive = alive;
  }

  /*
   * `drawLandPicker()` ĐÃ BỊ XOÁ CÙNG "3 LAND" — LUẬT ĐỔI, KHÔNG PHẢI "DỌN CHO GỌN".
   * Hàm đó vẽ 3 dải sáng ngang trên sân để người chơi biết "tướng sẽ ra ở dải này". Nay không còn
   * dải nào: quân ra ở ĐÚNG chỗ người chơi thả (hoặc ở Nhà nếu TAP avatar), nên không có gì để tô
   * sáng. Giữ lại sẽ là một lớp phủ vô nghĩa đè lên sông/ cầu.
   */

  /** Dòng số liệu nhỏ (FPS/ đơn vị/ tài nguyên) — cho công cụ đo và cho người chơi tò mò. */
  private drawDebugText(w: ArenaSceneWorld): void {
    const txt = this.hudText;
    if (!txt) return;
    if (this.frameCount++ % 15 !== 0) return;
    txt.setText(
      t(
        '{fps} FPS · đơn vị {u} · tài nguyên {res}',
        '{fps} FPS · units {u} · resource {res}',
        {
          fps: Math.round(this.game.loop.actualFps),
          u: w.units.length,
          res: Math.floor(w.resource.left),
        },
      ),
    );
  }

  /**
   * ĐỔI NGÔN NGỮ ⇒ VẼ LẠI CHỮ DO PHASER QUẢN.
   *
   * ⚠️ Vì sao cần hàm riêng: tên 2 phe (và nhãn HUD Nhà) được tạo MỘT LẦN trong `ArenaBattleView`.
   * Không có đường vẽ lại thì đổi VI→EN giữa trận sẽ để lại chữ tiếng Việt trên sân — lỗi mà
   * `tests/i18n.test.ts` không bắt được (nó kiểm bảng dịch, không kiểm Phaser).
   */
  refreshLang(): void {
    if (this.disposed) return;
    this.view.refreshLang();
    this.units.refreshNameTags();
  }

  /** Cho công cụ đo/ ảnh chụp tự động — cùng khuôn `ArenaScene.debugInfo`. */
  debugInfo(): Record<string, number> {
    return {
      fps: Math.round(this.game.loop.actualFps),
      units: this.world?.units.length ?? 0,
      sprites: this.units?.spriteCount ?? 0,
      scrollX: this.cam?.geometry.scrollX ?? 0,
      arenaW: ARENA_WORLD.w,
      arenaH: ARENA_WORLD.h,
      /* BÓNG XEM TRƯỚC — số liệu THẬT cho công cụ kiểm chứng (xem `ArenaDeployGhost`) */
      ghostSprites: this.ghost?.spriteCount ?? 0,
      ghostVisible: this.ghost?.isVisible ? 1 : 0,
    };
  }

  /**
   * DỌN SẠCH — scene là MÀN THỨ BA, người chơi vào/ ra nhiều lần trong một phiên.
   *
   * ⚠️ Không dọn thì sprite/ texture rò rỉ qua từng trận (repo đã có bài học này ở
   * `ArenaBattleView.dispose`). Đặt cờ `disposed` TRƯỚC khi huỷ để mọi callback đến muộn (ảnh nạp
   * bất đồng bộ, sự kiện đã xếp hàng) tự bỏ qua — đụng vào GameObject của scene đã chết là nguồn lỗi
   * khó tái hiện.
   */
  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.scale.off('resize', this.onScaleResize, this);
    /* KHỔ DỌC: gỡ listener/ camera phụ + TRẢ CANVAS VỀ CỠ THIẾT KẾ (xem `teardownPortrait`). */
    this.teardownPortrait();
    /*
     * BÓNG XEM TRƯỚC — huỷ THẬT (không chỉ ẩn): scene là màn thứ ba, vào/ ra nhiều lần một phiên,
     * và bộ sprite của bóng phải được trả lại như mọi GameObject khác. `hide()` chỉ lật cờ nên nó
     * KHÔNG đủ ở đây.
     */
    this.ghost?.dispose();
    this.ghostClock = 0;
    this.unitAdapter?.dispose();
    this.units?.reset();
    this.view?.dispose();
    this.cam?.dispose();
    this.fxGfx?.destroy();
    this.fxActive = [];
    this.ultFx?.dispose();
    this.hudText?.destroy();
    this.eventBuf = [];
    this.world = null;
  }
}
